import { LocationDistrict } from "@/lib/types";

const _ALL_DISTRICTS_FLAT: Record<string, Omit<LocationDistrict, 'state_code' | 'district_path'>> = {
  "nicobar": {
    "value": "AN_NI",
    "new_code": "NICOBAR",
    "label": "Nicobar",
    "rank": 1,
    "name_hi": "निकोबार",
    "local_name": "निकोबार"
  },
  "north-and-middle-andaman": {
    "value": "AN_NA",
    "new_code": "NORTH_AND_MIDDLE_ANDAMAN",
    "label": "North and Middle Andaman",
    "rank": 2,
    "name_hi": "उत्तर और मध्य अंडमान",
    "local_name": "उत्तर और मध्य अंडमान"
  },
  "south-andaman": {
    "value": "AN_SA",
    "new_code": "SOUTH_ANDAMAN",
    "label": "South Andaman",
    "rank": 3,
    "name_hi": "दक्षिण अंडमान",
    "local_name": "दक्षिण अंडमान"
  },
  "anantapur": {
    "value": "AP_AN",
    "new_code": "ANANTAPUR",
    "label": "Anantapur",
    "rank": 4,
    "name_hi": "अनंतपुर",
    "local_name": "అనంతపురము",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567220067_652.webp"
  },
  "chittoor": {
    "value": "AP_CH",
    "new_code": "CHITTOOR",
    "label": "Chittoor",
    "rank": 5,
    "name_hi": "चित्तूर",
    "local_name": "చిత్తూరు",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576007379_746.jpg"
  },
  "east-godavari": {
    "value": "AP_EG",
    "new_code": "EAST_GODAVARI",
    "label": "East Godavari",
    "rank": 6,
    "name_hi": "पूर्वी गोदावरी",
    "local_name": "తూర్పు గోదావరి",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567189321_21.jpg"
  },
  "guntur": {
    "value": "AP_GU",
    "new_code": "GUNTUR",
    "label": "Guntur",
    "rank": 7,
    "name_hi": "गुंटूर",
    "local_name": "గుంటూరు",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567282626_439.webp"
  },
  "ysr": {
    "value": "AP_CU",
    "new_code": "YSR",
    "label": "YSR",
    "rank": 8,
    "name_hi": "कडपा",
    "local_name": "వై ఎస్ ఆర్",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576073684_872.jpg"
  },
  "krishna": {
    "value": "AP_KR",
    "new_code": "KRISHNA",
    "label": "Krishna",
    "rank": 9,
    "name_hi": "कृष्णा",
    "local_name": "కృష్ణ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567087028_471.jpg"
  },
  "kurnool": {
    "value": "AP_KU",
    "new_code": "KURNOOL",
    "label": "Kurnool",
    "rank": 10,
    "name_hi": "कुरनूल",
    "local_name": "కర్నూల్",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567091317_461.jpg"
  },
  "prakasam": {
    "value": "AP_PR",
    "new_code": "PRAKASAM",
    "label": "Prakasam",
    "rank": 11,
    "name_hi": "प्रकाशम",
    "local_name": "ప్రకాశం",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567317176_873.webp"
  },
  "sri-potti-sriramulu-nellore": {
    "value": "AP_NE",
    "new_code": "SRI_POTTI_SRIRAMULU_NELLORE",
    "label": "Sri Potti Sriramulu Nellore",
    "rank": 12,
    "name_hi": "श्री पोट्टि श्रीरामुलु नेल्लोर",
    "local_name": "శ్రీ పొట్టి శ్రీరాములు నెల్లూరు",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576049813_303.jpg"
  },
  "srikakulam": {
    "value": "AP_SR",
    "new_code": "SRIKAKULAM",
    "label": "Srikakulam",
    "rank": 13,
    "name_hi": "श्रीकाकुलम",
    "local_name": "శ్రీకాకుళం",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576213364_607.jpg"
  },
  "visakhapatnam": {
    "value": "AP_VS",
    "new_code": "VISAKHAPATNAM",
    "label": "Visakhapatnam",
    "rank": 14,
    "name_hi": "विशाखापत्तनम",
    "local_name": "విశాఖపట్నం",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567092872_253.jpg"
  },
  "vizianagaram": {
    "value": "AP_VZ",
    "new_code": "VIZIANAGARAM",
    "label": "Vizianagaram",
    "rank": 15,
    "name_hi": "विजयनगरम",
    "local_name": "విజయనగరం",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576239638_767.jpg"
  },
  "west-godavari": {
    "value": "AP_WG",
    "new_code": "WEST_GODAVARI",
    "label": "West Godavari",
    "rank": 16,
    "name_hi": "पश्चिम गोदावरी",
    "local_name": "పశ్చిమ గోదావరి",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567089655_12.webp"
  },
  "anjaw": {
    "value": "AR_AJ",
    "new_code": "ANJAW",
    "label": "Anjaw",
    "rank": 17,
    "name_hi": "अन्जाव",
    "local_name": "अन्जाव"
  },
  "changlang": {
    "value": "AR_CH",
    "new_code": "CHANGLANG",
    "label": "Changlang",
    "rank": 18,
    "name_hi": "चांगलांग",
    "local_name": "चांगलांग"
  },
  "east-kameng": {
    "value": "AR_EK",
    "new_code": "EAST_KAMENG",
    "label": "East Kameng",
    "rank": 19,
    "name_hi": "पूर्वी कामेंग",
    "local_name": "पूर्वी कामेंग"
  },
  "east-siang": {
    "value": "AR_ES",
    "new_code": "EAST_SIANG",
    "label": "East Siang",
    "rank": 20,
    "name_hi": "पूर्वी सियांग",
    "local_name": "पूर्वी सियांग"
  },
  "kamle": {
    "value": "AR_KA",
    "new_code": "KAMLE",
    "label": "Kamle",
    "rank": 21,
    "name_hi": "सियांग",
    "local_name": "सियांग"
  },
  "kra-daadi": {
    "value": "AR_KR",
    "new_code": "KRA_DAADI",
    "label": "Kra Daadi",
    "rank": 22,
    "name_hi": "",
    "local_name": ""
  },
  "kurung-kumey": {
    "value": "AR_KK",
    "new_code": "KURUNG_KUMEY",
    "label": "Kurung Kumey",
    "rank": 23,
    "name_hi": "कुरुंग कुमे",
    "local_name": "कुरुंग कुमे"
  },
  "lepa-rada": {
    "value": "AR_LE",
    "new_code": "LEPA_RADA",
    "label": "Lepa-Rada",
    "rank": 24,
    "name_hi": "",
    "local_name": ""
  },
  "lohit": {
    "value": "AR_EL",
    "new_code": "LOHIT",
    "label": "Lohit",
    "rank": 25,
    "name_hi": "लोहित",
    "local_name": "लोहित"
  },
  "longding": {
    "value": "AR_LD",
    "new_code": "LONGDING",
    "label": "Longding",
    "rank": 26,
    "name_hi": "लोंगडिंग",
    "local_name": "लोंगडिंग"
  },
  "lower-dibang-valley": {
    "value": "AR_DV",
    "new_code": "LOWER_DIBANG_VALLEY",
    "label": "Lower Dibang Valley",
    "rank": 27,
    "name_hi": "निचली दिबांग घाटी",
    "local_name": "निचली दिबांग घाटी"
  },
  "lower-siang": {
    "value": "AR_LS",
    "new_code": "LOWER_SIANG",
    "label": "Lower Siang",
    "rank": 28,
    "name_hi": "",
    "local_name": ""
  },
  "lower-subansiri": {
    "value": "AR_LB",
    "new_code": "LOWER_SUBANSIRI",
    "label": "Lower Subansiri",
    "rank": 29,
    "name_hi": "लोअर सुबनसिरी",
    "local_name": "लोअर सुबनसिरी"
  },
  "namsai": {
    "value": "AR_NA",
    "new_code": "NAMSAI",
    "label": "Namsai",
    "rank": 30,
    "name_hi": "",
    "local_name": ""
  },
  "pakke-kessang": {
    "value": "AR_PK",
    "new_code": "PAKKE_KESSANG",
    "label": "Pakke-Kessang",
    "rank": 31,
    "name_hi": "",
    "local_name": ""
  },
  "papum-pare": {
    "value": "AR_PA",
    "new_code": "PAPUM_PARE",
    "label": "Papum Pare",
    "rank": 32,
    "name_hi": "पापुम पारे",
    "local_name": "पापुम पारे"
  },
  "shi-yomi": {
    "value": "AR_SY",
    "new_code": "SHI_YOMI",
    "label": "Shi-Yomi",
    "rank": 33,
    "name_hi": "",
    "local_name": ""
  },
  "central-siang": {
    "value": "AR_SI",
    "new_code": "CENTRAL_SIANG",
    "label": "Central Siang",
    "rank": 34,
    "name_hi": "",
    "local_name": ""
  },
  "tawang": {
    "value": "AR_TA",
    "new_code": "TAWANG",
    "label": "Tawang",
    "rank": 35,
    "name_hi": "तवांग",
    "local_name": "तवांग"
  },
  "tirap": {
    "value": "AR_TI",
    "new_code": "TIRAP",
    "label": "Tirap",
    "rank": 36,
    "name_hi": "तिरप",
    "local_name": "तिरप"
  },
  "dibang-valley": {
    "value": "AR_UD",
    "new_code": "DIBANG_VALLEY",
    "label": "Dibang Valley",
    "rank": 37,
    "name_hi": "ऊपरी दिबांग घाटी",
    "local_name": "ऊपरी दिबांग घाटी"
  },
  "upper-siang": {
    "value": "AR_US",
    "new_code": "UPPER_SIANG",
    "label": "Upper Siang",
    "rank": 38,
    "name_hi": "अपर सियांग",
    "local_name": "अपर सियांग"
  },
  "upper-subansiri": {
    "value": "AR_UB",
    "new_code": "UPPER_SUBANSIRI",
    "label": "Upper Subansiri",
    "rank": 39,
    "name_hi": "अपर सुबनसिरी",
    "local_name": "अपर सुबनसिरी"
  },
  "west-kameng": {
    "value": "AR_WK",
    "new_code": "WEST_KAMENG",
    "label": "West Kameng",
    "rank": 40,
    "name_hi": "पश्चिम कामेंग",
    "local_name": "पश्चिम कामेंग"
  },
  "west-siang": {
    "value": "AR_WS",
    "new_code": "WEST_SIANG",
    "label": "West Siang",
    "rank": 41,
    "name_hi": "पश्चिम सियांग",
    "local_name": "पश्चिम सियांग"
  },
  "baksa": {
    "value": "AS_BK",
    "new_code": "BAKSA",
    "label": "Baksa",
    "rank": 42,
    "name_hi": "बक्सा",
    "local_name": "বাক্সা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567531074_985.webp"
  },
  "barpeta": {
    "value": "AS_BP",
    "new_code": "BARPETA",
    "label": "Barpeta",
    "rank": 43,
    "name_hi": "बारपेटा",
    "local_name": "বৰপেটা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567320693_465.jpg"
  },
  "biswanath": {
    "value": "AS_BS",
    "new_code": "BISWANATH",
    "label": "Biswanath",
    "rank": 44,
    "name_hi": "बिशानुथ",
    "local_name": "বিশ্বনাথ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567498682_457.jpg"
  },
  "bongaigaon": {
    "value": "AS_BO",
    "new_code": "BONGAIGAON",
    "label": "Bongaigaon",
    "rank": 45,
    "name_hi": "बोंगईगांव",
    "local_name": "বঙাইগাঁও",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567466195_991.jpg"
  },
  "cachar": {
    "value": "AS_CA",
    "new_code": "CACHAR",
    "label": "Cachar",
    "rank": 46,
    "name_hi": "कछार",
    "local_name": "কাছাৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576463355_279.jpg"
  },
  "charaideo": {
    "value": "AS_CD",
    "new_code": "CHARAIDEO",
    "label": "Charaideo",
    "rank": 47,
    "name_hi": "चराइडो",
    "local_name": "চৰাইদেউ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567364767_758.webp"
  },
  "chirang": {
    "value": "AS_CH",
    "new_code": "CHIRANG",
    "label": "Chirang",
    "rank": 48,
    "name_hi": "चिरांग",
    "local_name": "চিৰাং",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576411403_298.jpg"
  },
  "darrang": {
    "value": "AS_DR",
    "new_code": "DARRANG",
    "label": "Darrang",
    "rank": 49,
    "name_hi": "दरांग",
    "local_name": "দৰং",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567362313_257.webp"
  },
  "dhemaji": {
    "value": "AS_DM",
    "new_code": "DHEMAJI",
    "label": "Dhemaji",
    "rank": 50,
    "name_hi": "धेमाजी",
    "local_name": "ধেমাজি",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752576375094_984.webp"
  },
  "dhubri": {
    "value": "AS_DU",
    "new_code": "DHUBRI",
    "label": "Dhubri",
    "rank": 51,
    "name_hi": "धुबरी",
    "local_name": "ধুবুৰী",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567533383_399.jpg"
  },
  "dibrugarh": {
    "value": "AS_DI",
    "new_code": "DIBRUGARH",
    "label": "Dibrugarh",
    "rank": 52,
    "name_hi": "डिब्रूगढ़",
    "local_name": "ডিব্ৰুগড়",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567322391_314.jpg"
  },
  "dima-hasao": {
    "value": "AS_NC",
    "new_code": "DIMA_HASAO",
    "label": "Dima Hasao",
    "rank": 53,
    "name_hi": "दीमा हसाओ",
    "local_name": "ডিমা হাছাও"
  },
  "goalpara": {
    "value": "AS_GP",
    "new_code": "GOALPARA",
    "label": "Goalpara",
    "rank": 54,
    "name_hi": "गोलपाड़ा",
    "local_name": "গোৱালপাৰা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567323291_563.jpg"
  },
  "golaghat": {
    "value": "AS_GG",
    "new_code": "GOLAGHAT",
    "label": "Golaghat",
    "rank": 55,
    "name_hi": "गोलाघाट",
    "local_name": "গোলাঘাট",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567360773_222.jpg"
  },
  "hailakandi": {
    "value": "AS_HA",
    "new_code": "HAILAKANDI",
    "label": "Hailakandi",
    "rank": 56,
    "name_hi": "हैलाकांडी",
    "local_name": "হাইলাকান্দি",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567321628_758.jpg"
  },
  "hojai": {
    "value": "AS_HJ",
    "new_code": "HOJAI",
    "label": "Hojai",
    "rank": 57,
    "name_hi": "हुजाई",
    "local_name": "হোজাই",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567530403_831.jpg"
  },
  "jorhat": {
    "value": "AS_JO",
    "new_code": "JORHAT",
    "label": "Jorhat",
    "rank": 58,
    "name_hi": "जोरहाट",
    "local_name": "যোৰহাট",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/gif/m/2025/07_jul/15_tue/img_1752570927656_823.gif"
  },
  "kamrup": {
    "value": "AS_KU",
    "new_code": "KAMRUP",
    "label": "Kamrup",
    "rank": 59,
    "name_hi": "कामरूप",
    "local_name": "কামৰূপ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576445985_893.jpg"
  },
  "kamrup-metropolitan": {
    "value": "AS_KM",
    "new_code": "KAMRUP_METROPOLITAN",
    "label": "Kamrup Metropolitan",
    "rank": 60,
    "name_hi": "कामरूप महानगर",
    "local_name": "কামৰূপ মহানগৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576264996_790.jpg"
  },
  "east-karbi-anglong": {
    "value": "AS_KG",
    "new_code": "EAST_KARBI_ANGLONG",
    "label": "East Karbi Anglong",
    "rank": 61,
    "name_hi": "कार्बी आंगलोंग",
    "local_name": "পূৱ কাৰ্বি আংলং",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567466767_219.jpg"
  },
  "karimganj": {
    "value": "AS_KR",
    "new_code": "KARIMGANJ",
    "label": "Karimganj",
    "rank": 62,
    "name_hi": "करीमगंज",
    "local_name": "কৰিমগঞ্জ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567366052_107.jpg"
  },
  "kokrajhar": {
    "value": "AS_KJ",
    "new_code": "KOKRAJHAR",
    "label": "Kokrajhar",
    "rank": 63,
    "name_hi": "कोकराझार",
    "local_name": "কোকৰাঝাৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567431100_879.jpg"
  },
  "lakhimpur": {
    "value": "AS_LA",
    "new_code": "LAKHIMPUR",
    "label": "Lakhimpur",
    "rank": 64,
    "name_hi": "लखीमपुर",
    "local_name": "লখিমপুৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576339503_972.jpg"
  },
  "majuli": {
    "value": "AS_MJ",
    "new_code": "MAJULI",
    "label": "Majuli",
    "rank": 65,
    "name_hi": "माजुली",
    "local_name": "মাজুলী",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567434067_390.webp"
  },
  "morigaon": {
    "value": "AS_MA",
    "new_code": "MORIGAON",
    "label": "Morigaon",
    "rank": 66,
    "name_hi": "मोरीगांव",
    "local_name": "মৰিগাঁও",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567529511_158.jpg"
  },
  "nagaon": {
    "value": "AS_NN",
    "new_code": "NAGAON",
    "label": "Nagaon",
    "rank": 67,
    "name_hi": "नगांव",
    "local_name": "নগাঁও",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567397045_46.jpg"
  },
  "nalbari": {
    "value": "AS_NB",
    "new_code": "NALBARI",
    "label": "Nalbari",
    "rank": 68,
    "name_hi": "नलबाड़ी",
    "local_name": "নলবাৰী",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567465334_407.jpg"
  },
  "sivasagar": {
    "value": "AS_ST",
    "new_code": "SIVASAGAR",
    "label": "Sivasagar",
    "rank": 69,
    "name_hi": "शिवसागर",
    "local_name": "শিৱসাগৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567397990_987.jpg"
  },
  "south-salmara-mankachar": {
    "value": "AS_SM",
    "new_code": "SOUTH_SALMARA_MANKACHAR",
    "label": "South Salmara-Mankachar",
    "rank": 70,
    "name_hi": "दक्षिण सलमार-मनकाचर",
    "local_name": "দক্ষিণ শালমাৰা মানকাছাৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567497644_572.jpg"
  },
  "sonitpur": {
    "value": "AS_SO",
    "new_code": "SONITPUR",
    "label": "Sonitpur",
    "rank": 71,
    "name_hi": "सोनितपुर",
    "local_name": "শোণিতপুৰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752570929451_214.jpg"
  },
  "tinsukia": {
    "value": "AS_TI",
    "new_code": "TINSUKIA",
    "label": "Tinsukia",
    "rank": 72,
    "name_hi": "तिनसुकिया",
    "local_name": "তিনিচুকীয়া",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576284621_772.jpg"
  },
  "udalguri": {
    "value": "AS_UD",
    "new_code": "UDALGURI",
    "label": "Udalguri",
    "rank": 73,
    "name_hi": "उदलगुड़ी",
    "local_name": "ওডালগুৰি",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567326578_680.jpg"
  },
  "west-karbi-anglong": {
    "value": "AS_WK",
    "new_code": "WEST_KARBI_ANGLONG",
    "label": "West Karbi Anglong",
    "rank": 74,
    "name_hi": "पश्चिम करबी आंगलोंग",
    "local_name": "পশ্চিম কাৰ্বি আংলং",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576394940_176.jpg"
  },
  "araria": {
    "value": "BR_AR",
    "new_code": "ARARIA",
    "label": "Araria",
    "rank": 75,
    "name_hi": "अरवल",
    "local_name": "अररिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576597234_627.jpg"
  },
  "arwal": {
    "value": "BR_AW",
    "new_code": "ARWAL",
    "label": "Arwal",
    "rank": 76,
    "name_hi": "अरवल",
    "local_name": "अरवल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576529916_642.jpg"
  },
  "aurangabad": {
    "value": "BR_AU",
    "new_code": "AURANGABAD",
    "label": "Aurangabad",
    "rank": 77,
    "name_hi": "औरंगाबाद",
    "local_name": "औरंगाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576509475_851.jpg"
  },
  "banka": {
    "value": "BR_BA",
    "new_code": "BANKA",
    "label": "Banka",
    "rank": 78,
    "name_hi": "बांका",
    "local_name": "बांका",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567564613_12.jpg"
  },
  "begusarai": {
    "value": "BR_BE",
    "new_code": "BEGUSARAI",
    "label": "Begusarai",
    "rank": 79,
    "name_hi": "बेगूसराय",
    "local_name": "बेगूसराय",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576799711_992.jpg"
  },
  "bhagalpur": {
    "value": "BR_BG",
    "new_code": "BHAGALPUR",
    "label": "Bhagalpur",
    "rank": 80,
    "name_hi": "भागलपुर",
    "local_name": "भागलपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567855917_516.jpg"
  },
  "bhojpur": {
    "value": "BR_BJ",
    "new_code": "BHOJPUR",
    "label": "Bhojpur",
    "rank": 81,
    "name_hi": "भोजपुर",
    "local_name": "भोजपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576733290_894.jpg"
  },
  "buxar": {
    "value": "BR_BU",
    "new_code": "BUXAR",
    "label": "Buxar",
    "rank": 82,
    "name_hi": "बक्सर",
    "local_name": "बक्सर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567565470_13.jpg"
  },
  "darbhanga": {
    "value": "BR_DA",
    "new_code": "DARBHANGA",
    "label": "Darbhanga",
    "rank": 83,
    "name_hi": "दरभंगा",
    "local_name": "दरभंगा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567852821_697.jpg"
  },
  "east-champaran": {
    "value": "BR_EC",
    "new_code": "EAST_CHAMPARAN",
    "label": "East Champaran",
    "rank": 84,
    "name_hi": "पूर्वी चंपारण",
    "local_name": "पूर्वी चंपारण",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567917672_674.jpg"
  },
  "gaya": {
    "value": "BR_GA",
    "new_code": "GAYA",
    "label": "Gaya",
    "rank": 85,
    "name_hi": "गया",
    "local_name": "गया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567949436_857.jpg"
  },
  "gopalganj": {
    "value": "BR_GO",
    "new_code": "GOPALGANJ",
    "label": "Gopalganj",
    "rank": 86,
    "name_hi": "गोपालगंज",
    "local_name": "गोपालगंज",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567630172_992.jpg"
  },
  "jamui": {
    "value": "BR_JA",
    "new_code": "JAMUI",
    "label": "Jamui",
    "rank": 87,
    "name_hi": "जमुई",
    "local_name": "जमुई",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567853477_550.webp"
  },
  "jehanabad": {
    "value": "BR_JE",
    "new_code": "JEHANABAD",
    "label": "Jehanabad",
    "rank": 88,
    "name_hi": "जहानाबाद",
    "local_name": "जहानाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567567474_268.jpg"
  },
  "kaimur": {
    "value": "BR_KM",
    "new_code": "KAIMUR",
    "label": "Kaimur",
    "rank": 89,
    "name_hi": "कैमूर",
    "local_name": "कैमूर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567783863_906.jpg"
  },
  "katihar": {
    "value": "BR_KT",
    "new_code": "KATIHAR",
    "label": "Katihar",
    "rank": 90,
    "name_hi": "कटिहार",
    "local_name": "कटिहार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576629880_432.jpg"
  },
  "khagaria": {
    "value": "BR_KH",
    "new_code": "KHAGARIA",
    "label": "Khagaria",
    "rank": 91,
    "name_hi": "खगरिया",
    "local_name": "खगड़िया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576771889_16.jpg"
  },
  "kishanganj": {
    "value": "BR_KI",
    "new_code": "KISHANGANJ",
    "label": "Kishanganj",
    "rank": 92,
    "name_hi": "किशनगंज",
    "local_name": "किशनगंज",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567855282_648.jpg"
  },
  "lakhisarai": {
    "value": "BR_LA",
    "new_code": "LAKHISARAI",
    "label": "Lakhisarai",
    "rank": 93,
    "name_hi": "लखीसराय",
    "local_name": "लखीसराय",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567787362_531.jpg"
  },
  "madhepura": {
    "value": "BR_MP",
    "new_code": "MADHEPURA",
    "label": "Madhepura",
    "rank": 94,
    "name_hi": "मधेपुरा",
    "local_name": "मधेपुरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576566891_244.jpg"
  },
  "madhubani": {
    "value": "BR_MB",
    "new_code": "MADHUBANI",
    "label": "Madhubani",
    "rank": 95,
    "name_hi": "मधुबनी",
    "local_name": "मधुबनी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567631327_837.jpg"
  },
  "munger": {
    "value": "BR_MG",
    "new_code": "MUNGER",
    "label": "Munger",
    "rank": 96,
    "name_hi": "मुंगेर",
    "local_name": "मुंगेर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576716370_630.jpg"
  },
  "muzaffarpur": {
    "value": "BR_MZ",
    "new_code": "MUZAFFARPUR",
    "label": "Muzaffarpur",
    "rank": 97,
    "name_hi": "मुजफ्फरपुर",
    "local_name": "मुजफ्फरपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567786772_805.jpg"
  },
  "nalanda": {
    "value": "BR_NL",
    "new_code": "NALANDA",
    "label": "Nalanda",
    "rank": 98,
    "name_hi": "नालंदा",
    "local_name": "नालंदा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576873092_445.jpg"
  },
  "nawada": {
    "value": "BR_NW",
    "new_code": "NAWADA",
    "label": "Nawada",
    "rank": 99,
    "name_hi": "नवादा",
    "local_name": "नवादा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567851888_28.jpg"
  },
  "patna": {
    "value": "BR_PA",
    "new_code": "PATNA",
    "label": "Patna",
    "rank": 100,
    "name_hi": "पटना",
    "local_name": "पटना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567568005_105.jpg"
  },
  "purnia": {
    "value": "BR_PU",
    "new_code": "PURNIA",
    "label": "Purnia",
    "rank": 101,
    "name_hi": "पूर्णिया",
    "local_name": "पूर्णिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567818106_308.webp"
  },
  "rohtas": {
    "value": "BR_RO",
    "new_code": "ROHTAS",
    "label": "Rohtas",
    "rank": 102,
    "name_hi": "रोहतास",
    "local_name": "रोहतास",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567629299_299.jpg"
  },
  "saharsa": {
    "value": "BR_SH",
    "new_code": "SAHARSA",
    "label": "Saharsa",
    "rank": 103,
    "name_hi": "सहरसा",
    "local_name": "सहरसा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567566343_360.jpg"
  },
  "samastipur": {
    "value": "BR_SM",
    "new_code": "SAMASTIPUR",
    "label": "Samastipur",
    "rank": 104,
    "name_hi": "समस्तीपुर",
    "local_name": "समस्तीपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567851271_694.jpg"
  },
  "saran": {
    "value": "BR_SR",
    "new_code": "SARAN",
    "label": "Saran",
    "rank": 105,
    "name_hi": "सारण",
    "local_name": "सारण",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567785408_853.jpg"
  },
  "sheikhpura": {
    "value": "BR_SP",
    "new_code": "SHEIKHPURA",
    "label": "Sheikhpura",
    "rank": 106,
    "name_hi": "शेखपुरा",
    "local_name": "शेखपुरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567850566_768.jpg"
  },
  "sheohar": {
    "value": "BR_SO",
    "new_code": "SHEOHAR",
    "label": "Sheohar",
    "rank": 107,
    "name_hi": "शिवहर",
    "local_name": "शिवहर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567948315_330.jpg"
  },
  "sitamarhi": {
    "value": "BR_ST",
    "new_code": "SITAMARHI",
    "label": "Sitamarhi",
    "rank": 108,
    "name_hi": "सीतामढ़ी",
    "local_name": "सीतामढ़ी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576547924_148.jpg"
  },
  "siwan": {
    "value": "BR_SW",
    "new_code": "SIWAN",
    "label": "Siwan",
    "rank": 109,
    "name_hi": "सिवान",
    "local_name": "सिवान",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567786131_330.jpg"
  },
  "supaul": {
    "value": "BR_SU",
    "new_code": "SUPAUL",
    "label": "Supaul",
    "rank": 110,
    "name_hi": "सुपौल",
    "local_name": "सुपौल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752576849725_914.webp"
  },
  "vaishali": {
    "value": "BR_VA",
    "new_code": "VAISHALI",
    "label": "Vaishali",
    "rank": 111,
    "name_hi": "वैशाली",
    "local_name": "वैशाली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567916637_244.jpg"
  },
  "west-champaran": {
    "value": "BR_WC",
    "new_code": "WEST_CHAMPARAN",
    "label": "West Champaran",
    "rank": 112,
    "name_hi": "पश्चिम चंपारण",
    "local_name": "पश्चिम चंपारण",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576821292_932.jpg"
  },
  "chandigarh": {
    "value": "CH_CH",
    "new_code": "CHANDIGARH",
    "label": "Chandigarh",
    "rank": 113,
    "name_hi": "चंडीगढ़",
    "local_name": "चंडीगढ़"
  },
  "balod": {
    "value": "CG_BL",
    "new_code": "BALOD",
    "label": "Balod",
    "rank": 114,
    "name_hi": "मुंगेली",
    "local_name": "बालोद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567956401_412.jpg"
  },
  "baloda-bazar": {
    "value": "CG_BLB",
    "new_code": "BALODA_BAZAR",
    "label": "Baloda Bazar",
    "rank": 115,
    "name_hi": "बलौदा बाजार",
    "local_name": "बलौदा बाजार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567130521_508.jpg"
  },
  "balrampur": {
    "value": "UP_BP",
    "new_code": "BALRAMPUR",
    "label": "Balrampur",
    "rank": 626,
    "name_hi": "बलरामपुर",
    "local_name": "बलरामपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573712335_576.jpg"
  },
  "bastar": {
    "value": "CG_BA",
    "new_code": "BASTAR",
    "label": "Bastar",
    "rank": 117,
    "name_hi": "बस्तर",
    "local_name": "बस्तर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567138374_371.jpg"
  },
  "bemetara": {
    "value": "CG_BT",
    "new_code": "BEMETARA",
    "label": "Bemetara",
    "rank": 118,
    "name_hi": "बेमेतरा",
    "local_name": "बेमेतरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567121520_806.jpg"
  },
  "bijapur": {
    "value": "CG_BJ",
    "new_code": "BIJAPUR",
    "label": "Bijapur",
    "rank": 119,
    "name_hi": "बीजापुर",
    "local_name": "बीजापुर"
  },
  "bilaspur": {
    "value": "HP_BI",
    "new_code": "BILASPUR",
    "label": "Bilaspur",
    "rank": 212,
    "name_hi": "बिलासपुर",
    "local_name": "बिलासपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752577129824_373.webp"
  },
  "dantewada": {
    "value": "CG_DA",
    "new_code": "DANTEWADA",
    "label": "Dantewada",
    "rank": 121,
    "name_hi": "दंतेवाड़ा",
    "local_name": "दंतेवाड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567131261_661.jpg"
  },
  "dhamtari": {
    "value": "CG_DH",
    "new_code": "DHAMTARI",
    "label": "Dhamtari",
    "rank": 122,
    "name_hi": "धमतरी",
    "local_name": "धमतरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567088420_276.jpg"
  },
  "durg": {
    "value": "CG_DU",
    "new_code": "DURG",
    "label": "Durg",
    "rank": 123,
    "name_hi": "दुर्ग",
    "local_name": "दुर्ग",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576894240_378.jpg"
  },
  "gariaband": {
    "value": "CG_GB",
    "new_code": "GARIABAND",
    "label": "Gariaband",
    "rank": 124,
    "name_hi": "गरियाबंद",
    "local_name": "गरियाबंद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567122995_415.jpg"
  },
  "janjgir-champa": {
    "value": "CG_JC",
    "new_code": "JANJGIR_CHAMPA",
    "label": "Janjgir-Champa",
    "rank": 125,
    "name_hi": "जांजगीर-चंपा",
    "local_name": "जांजगीर-चंपा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567135728_709.jpg"
  },
  "jashpur": {
    "value": "CG_JA",
    "new_code": "JASHPUR",
    "label": "Jashpur",
    "rank": 126,
    "name_hi": "जशपुर",
    "local_name": "जशपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567128674_261.jpg"
  },
  "kabirdham": {
    "value": "CG_KW",
    "new_code": "KABIRDHAM",
    "label": "Kabirdham",
    "rank": 127,
    "name_hi": "कबीरधाम (कवर्धा)",
    "local_name": "कबीरधाम (कवर्धा)",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567176318_859.jpg"
  },
  "kanker": {
    "value": "CG_KK",
    "new_code": "KANKER",
    "label": "Kanker",
    "rank": 128,
    "name_hi": "कांकेर",
    "local_name": "कांकेर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567137023_670.jpg"
  },
  "kondagaon": {
    "value": "CG_KG",
    "new_code": "KONDAGAON",
    "label": "Kondagaon",
    "rank": 129,
    "name_hi": "कोंडागांव",
    "local_name": "कोंडागांव",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567126938_850.jpg"
  },
  "korba": {
    "value": "CG_KB",
    "new_code": "KORBA",
    "label": "Korba",
    "rank": 130,
    "name_hi": "कोरबा",
    "local_name": "कोरबा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567961469_882.webp"
  },
  "korea": {
    "value": "CG_KJ",
    "new_code": "KOREA",
    "label": "Korea",
    "rank": 131,
    "name_hi": "कोरिया",
    "local_name": "कोरिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567955640_214.jpg"
  },
  "mahasamund": {
    "value": "CG_MA",
    "new_code": "MAHASAMUND",
    "label": "Mahasamund",
    "rank": 132,
    "name_hi": "महासमुंद",
    "local_name": "महासमुंद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567963037_415.jpg"
  },
  "mungeli": {
    "value": "CG_ML",
    "new_code": "MUNGELI",
    "label": "Mungeli",
    "rank": 133,
    "name_hi": "मुंगेली",
    "local_name": "मुंगेली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567953428_374.jpg"
  },
  "narayanpur": {
    "value": "CG_NR",
    "new_code": "NARAYANPUR",
    "label": "Narayanpur",
    "rank": 134,
    "name_hi": "नारायणपुर",
    "local_name": "नारायणपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567954194_319.jpg"
  },
  "raigarh": {
    "value": "CG_RG",
    "new_code": "RAIGARH",
    "label": "Raigarh",
    "rank": 135,
    "name_hi": "रायगढ़",
    "local_name": "रायगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567124241_241.jpg"
  },
  "raipur": {
    "value": "CG_RP",
    "new_code": "RAIPUR",
    "label": "Raipur",
    "rank": 136,
    "name_hi": "रायपुर",
    "local_name": "रायपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567177477_148.webp"
  },
  "rajnandgaon": {
    "value": "CG_RN",
    "new_code": "RAJNANDGAON",
    "label": "Rajnandgaon",
    "rank": 137,
    "name_hi": "राजनांदगांव",
    "local_name": "राजनांदगांव",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567950423_790.jpg"
  },
  "sukma": {
    "value": "CG_SK",
    "new_code": "SUKMA",
    "label": "Sukma",
    "rank": 138,
    "name_hi": "सुकमा",
    "local_name": "सुकमा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567181457_115.jpg"
  },
  "surajpur": {
    "value": "CG_SJ",
    "new_code": "SURAJPUR",
    "label": "Surajpur",
    "rank": 139,
    "name_hi": "सरगुजा",
    "local_name": "सूरजपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567952294_829.webp"
  },
  "surguja": {
    "value": "CG_SG",
    "new_code": "SURGUJA",
    "label": "Surguja",
    "rank": 140,
    "name_hi": "सरगुजा",
    "local_name": "सरगुजा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567119732_880.webp"
  },
  "dadra-and-nagar-haveli": {
    "value": "DN_DN",
    "new_code": "DADRA_AND_NAGAR_HAVELI",
    "label": "Dadra and Nagar Haveli",
    "rank": 141,
    "name_hi": "दादरा और नगर हवेली",
    "local_name": "दादरा और नगर हवेली"
  },
  "daman": {
    "value": "DD_DA",
    "new_code": "DAMAN",
    "label": "Daman",
    "rank": 142,
    "name_hi": "दमन",
    "local_name": "दमन"
  },
  "diu": {
    "value": "DD_DI",
    "new_code": "DIU",
    "label": "Diu",
    "rank": 143,
    "name_hi": "दीव",
    "local_name": "दीव"
  },
  "central-delhi": {
    "value": "DL_CD",
    "new_code": "CENTRAL_DELHI",
    "label": "Central Delhi",
    "rank": 144,
    "name_hi": "मध्य दिल्ली",
    "local_name": "मध्य दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567223338_37.jpg"
  },
  "east-delhi": {
    "value": "DL_ED",
    "new_code": "EAST_DELHI",
    "label": "East Delhi",
    "rank": 145,
    "name_hi": "पूर्वी दिल्ली",
    "local_name": "पूर्वी दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567185377_617.jpg"
  },
  "new-delhi": {
    "value": "DL_ND",
    "new_code": "NEW_DELHI",
    "label": "New Delhi",
    "rank": 146,
    "name_hi": "नई दिल्ली",
    "local_name": "नई दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567224287_827.jpg"
  },
  "north-delhi": {
    "value": "DL_NO",
    "new_code": "NORTH_DELHI",
    "label": "North Delhi",
    "rank": 147,
    "name_hi": "उत्तरी दिल्ली",
    "local_name": "उत्तरी दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567217479_597.jpg"
  },
  "north-east-delhi": {
    "value": "DL_NE",
    "new_code": "NORTH_EAST_DELHI",
    "label": "North East Delhi",
    "rank": 148,
    "name_hi": "उत्तर पूर्वी दिल्ली",
    "local_name": "उत्तर पूर्वी दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567218348_418.jpg"
  },
  "north-west-delhi": {
    "value": "DL_NW",
    "new_code": "NORTH_WEST_DELHI",
    "label": "North West Delhi",
    "rank": 149,
    "name_hi": "उत्तर पश्चिम दिल्ली",
    "local_name": "उत्तर पश्चिम दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567221777_257.jpg"
  },
  "shahdara": {
    "value": "DL_SH",
    "new_code": "SHAHDARA",
    "label": "Shahdara",
    "rank": 150,
    "name_hi": "शाहदरा",
    "local_name": "शाहदरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571501157_123.jpg"
  },
  "south-delhi": {
    "value": "DL_SD",
    "new_code": "SOUTH_DELHI",
    "label": "South Delhi",
    "rank": 151,
    "name_hi": "दक्षिण दिल्ली",
    "local_name": "दक्षिण दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567183688_320.jpg"
  },
  "south-east-delhi": {
    "value": "DL_SE",
    "new_code": "SOUTH_EAST_DELHI",
    "label": "South East Delhi",
    "rank": 152,
    "name_hi": "दक्षिण पूर्वी दिल्ली",
    "local_name": "दक्षिण पूर्वी दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567219932_982.jpg"
  },
  "south-west-delhi": {
    "value": "DL_SW",
    "new_code": "SOUTH_WEST_DELHI",
    "label": "South West Delhi",
    "rank": 153,
    "name_hi": "दक्षिण पश्चिम दिल्ली",
    "local_name": "दक्षिण पश्चिम दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567182283_920.jpg"
  },
  "west-delhi": {
    "value": "DL_WD",
    "new_code": "WEST_DELHI",
    "label": "West Delhi",
    "rank": 154,
    "name_hi": "पश्चिम दिल्ली",
    "local_name": "पश्चिम दिल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567186895_324.jpg"
  },
  "north-goa": {
    "value": "GA_NG",
    "new_code": "NORTH_GOA",
    "label": "North Goa",
    "rank": 155,
    "name_hi": "उत्तर गोवा",
    "local_name": "उत्तर गोवा"
  },
  "south-goa": {
    "value": "GA_SG",
    "new_code": "SOUTH_GOA",
    "label": "South Goa",
    "rank": 156,
    "name_hi": "दक्षिण गोवा",
    "local_name": "दक्षिण गोवा"
  },
  "ahmedabad": {
    "value": "GJ_AH",
    "new_code": "AHMEDABAD",
    "label": "Ahmedabad",
    "rank": 157,
    "name_hi": "अहमदाबाद",
    "local_name": "અમદાવાદ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567232156_603.jpg"
  },
  "amreli": {
    "value": "GJ_AM",
    "new_code": "AMRELI",
    "label": "Amreli",
    "rank": 158,
    "name_hi": "अमरेली",
    "local_name": "અમરેલી ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567413506_213.jpg"
  },
  "anand": {
    "value": "GJ_AN",
    "new_code": "ANAND",
    "label": "Anand",
    "rank": 159,
    "name_hi": "आनंद",
    "local_name": "આણંદ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567412642_108.jpg"
  },
  "aravallis": {
    "value": "GJ_AR",
    "new_code": "ARAVALLIS",
    "label": "Aravallis",
    "rank": 160,
    "name_hi": "अरावली",
    "local_name": "અરવલ્લી",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567224909_678.jpg"
  },
  "banas-kantha": {
    "value": "GJ_BK",
    "new_code": "BANAS_KANTHA",
    "label": "Banas Kantha",
    "rank": 161,
    "name_hi": "बनासकांठा",
    "local_name": "બનાસકાંઠા",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567230736_66.jpg"
  },
  "bharuch": {
    "value": "GJ_BR",
    "new_code": "BHARUCH",
    "label": "Bharuch",
    "rank": 162,
    "name_hi": "भरूच",
    "local_name": "ભરૂચ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567302091_661.webp"
  },
  "bhavnagar": {
    "value": "GJ_BV",
    "new_code": "BHAVNAGAR",
    "label": "Bhavnagar",
    "rank": 163,
    "name_hi": "भावनगर",
    "local_name": "ભાવનગર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567233756_398.jpg"
  },
  "botad": {
    "value": "GJ_BT",
    "new_code": "BOTAD",
    "label": "Botad",
    "rank": 164,
    "name_hi": "बोटाड",
    "local_name": "બોટાદ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576930312_697.jpg"
  },
  "chhota-udepur": {
    "value": "GJ_CU",
    "new_code": "CHHOTA_UDEPUR",
    "label": "Chhota Udepur",
    "rank": 165,
    "name_hi": "छोटा उदेपुर",
    "local_name": "છોટાઉદેપુર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567308431_639.jpg"
  },
  "dahod": {
    "value": "GJ_DA",
    "new_code": "DAHOD",
    "label": "Dahod",
    "rank": 166,
    "name_hi": "दाहोद",
    "local_name": "દાહોદ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567303679_650.jpg"
  },
  "the-dangs": {
    "value": "GJ_DG",
    "new_code": "THE_DANGS",
    "label": "The Dangs",
    "rank": 167,
    "name_hi": "डैंग",
    "local_name": "ડાંગ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752577041416_290.webp"
  },
  "devbhoomi-dwarka": {
    "value": "GJ_DD",
    "new_code": "DEVBHOOMI_DWARKA",
    "label": "Devbhoomi Dwarka",
    "rank": 168,
    "name_hi": "देवभूमि द्वारका",
    "local_name": "દેવભૂમિ દ્વારકા",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567310428_885.jpg"
  },
  "gandhinagar": {
    "value": "GJ_GA",
    "new_code": "GANDHINAGAR",
    "label": "Gandhinagar",
    "rank": 169,
    "name_hi": "गांधीनगर",
    "local_name": "ગાંધીનગર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567234296_617.jpg"
  },
  "gir-somnath": {
    "value": "GJ_GS",
    "new_code": "GIR_SOMNATH",
    "label": "Gir Somnath",
    "rank": 170,
    "name_hi": "गिर सोमनाथ",
    "local_name": "ગીર સોમનાથ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577016246_156.jpg"
  },
  "jamnagar": {
    "value": "GJ_JA",
    "new_code": "JAMNAGAR",
    "label": "Jamnagar",
    "rank": 171,
    "name_hi": "जामनगर",
    "local_name": "જામનગર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567418012_861.jpg"
  },
  "junagadh": {
    "value": "GJ_JU",
    "new_code": "JUNAGADH",
    "label": "Junagadh",
    "rank": 172,
    "name_hi": "जूनागढ़",
    "local_name": "જુનાગઢ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567414827_818.jpg"
  },
  "kheda": {
    "value": "GJ_KH",
    "new_code": "KHEDA",
    "label": "Kheda",
    "rank": 173,
    "name_hi": "खेड़ा",
    "local_name": "ખેડા",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567377473_803.jpg"
  },
  "kutch": {
    "value": "GJ_KA",
    "new_code": "KUTCH",
    "label": "Kutch",
    "rank": 174,
    "name_hi": "कच्छ",
    "local_name": "કચ્છ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567230069_788.jpg"
  },
  "mahisagar": {
    "value": "GJ_MH",
    "new_code": "MAHISAGAR",
    "label": "Mahisagar",
    "rank": 175,
    "name_hi": "महिसागर",
    "local_name": "મહિસાગર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576977183_460.jpg"
  },
  "mahesana": {
    "value": "GJ_MA",
    "new_code": "MAHESANA",
    "label": "Mahesana",
    "rank": 176,
    "name_hi": "मेहसाणा",
    "local_name": "મહેસાણા",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567313870_33.jpg"
  },
  "morbi": {
    "value": "GJ_MB",
    "new_code": "MORBI",
    "label": "Morbi",
    "rank": 177,
    "name_hi": "मोरबी",
    "local_name": "મોરબી",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567235015_428.jpg"
  },
  "narmada": {
    "value": "GJ_NR",
    "new_code": "NARMADA",
    "label": "Narmada",
    "rank": 178,
    "name_hi": "नर्मदा",
    "local_name": "નર્મદા",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567416194_210.jpg"
  },
  "navsari": {
    "value": "GJ_NV",
    "new_code": "NAVSARI",
    "label": "Navsari",
    "rank": 179,
    "name_hi": "नवसारी",
    "local_name": "નવસારી",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567380128_518.jpg"
  },
  "panch-mahals": {
    "value": "GJ_PM",
    "new_code": "PANCH_MAHALS",
    "label": "Panch Mahals",
    "rank": 180,
    "name_hi": "पंचमहल",
    "local_name": "પંચમહાલ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567344728_76.jpg"
  },
  "patan": {
    "value": "GJ_PA",
    "new_code": "PATAN",
    "label": "Patan",
    "rank": 181,
    "name_hi": "पाटन",
    "local_name": "પાટણ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567419934_522.jpg"
  },
  "porbandar": {
    "value": "GJ_PO",
    "new_code": "PORBANDAR",
    "label": "Porbandar",
    "rank": 182,
    "name_hi": "पोरबंदर",
    "local_name": "પોરબંદર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567306889_6.jpg"
  },
  "rajkot": {
    "value": "GJ_RA",
    "new_code": "RAJKOT",
    "label": "Rajkot",
    "rank": 183,
    "name_hi": "राजकोट",
    "local_name": "રાજકોટ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567417182_296.jpg"
  },
  "sabar-kantha": {
    "value": "GJ_SK",
    "new_code": "SABAR_KANTHA",
    "label": "Sabar Kantha",
    "rank": 184,
    "name_hi": "साबरकांठा",
    "local_name": "સાબરકાંઠા",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567239896_966.jpg"
  },
  "surat": {
    "value": "GJ_ST",
    "new_code": "SURAT",
    "label": "Surat",
    "rank": 185,
    "name_hi": "सूरत",
    "local_name": "સુરત",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567311569_828.jpg"
  },
  "surendranagar": {
    "value": "GJ_SN",
    "new_code": "SURENDRANAGAR",
    "label": "Surendranagar",
    "rank": 186,
    "name_hi": "सुरेंद्रनगर",
    "local_name": "સુરેન્દ્રનગર",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567304581_304.jpg"
  },
  "tapi": {
    "value": "GJ_TA",
    "new_code": "TAPI",
    "label": "Tapi",
    "rank": 187,
    "name_hi": "तापी",
    "local_name": "તાપી",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567379460_679.jpg"
  },
  "vadodara": {
    "value": "GJ_VD",
    "new_code": "VADODARA",
    "label": "Vadodara",
    "rank": 188,
    "name_hi": "वडोदरा",
    "local_name": "વડોદરા ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577062323_844.jpg"
  },
  "valsad": {
    "value": "GJ_VL",
    "new_code": "VALSAD",
    "label": "Valsad",
    "rank": 189,
    "name_hi": "वलसाड",
    "local_name": "વલસાડ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577080336_290.jpg"
  },
  "ambala": {
    "value": "HR_AM",
    "new_code": "AMBALA",
    "label": "Ambala",
    "rank": 190,
    "name_hi": "अंबाला",
    "local_name": "अम्बाला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567490820_144.jpg"
  },
  "bhiwani": {
    "value": "HR_BH",
    "new_code": "BHIWANI",
    "label": "Bhiwani",
    "rank": 191,
    "name_hi": "भिवानी",
    "local_name": "भिवानी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567467477_709.jpg"
  },
  "charkhi-dadri": {
    "value": "HR_CD",
    "new_code": "CHARKHI_DADRI",
    "label": "Charkhi Dadri",
    "rank": 192,
    "name_hi": "चरखी दादरी",
    "local_name": "चरखी दादरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567473465_39.jpg"
  },
  "faridabad": {
    "value": "HR_FR",
    "new_code": "FARIDABAD",
    "label": "Faridabad",
    "rank": 193,
    "name_hi": "फरीदाबाद",
    "local_name": "फरीदाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567494066_915.jpg"
  },
  "fatehabad": {
    "value": "HR_FT",
    "new_code": "FATEHABAD",
    "label": "Fatehabad",
    "rank": 194,
    "name_hi": "फतेहाबाद",
    "local_name": "फतेहाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567484358_203.jpg"
  },
  "gurugram": {
    "value": "HR_GU",
    "new_code": "GURUGRAM",
    "label": "Gurugram",
    "rank": 195,
    "name_hi": "गुरुग्राम",
    "local_name": "गुरुग्राम",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567489000_786.jpg"
  },
  "hissar": {
    "value": "HR_HI",
    "new_code": "HISSAR",
    "label": "Hissar",
    "rank": 196,
    "name_hi": "हिसार",
    "local_name": "हिसार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567486891_545.jpg"
  },
  "jhajjar": {
    "value": "HR_JH",
    "new_code": "JHAJJAR",
    "label": "Jhajjar",
    "rank": 197,
    "name_hi": "झज्जर",
    "local_name": "झज्जर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567477528_875.jpg"
  },
  "jind": {
    "value": "HR_JI",
    "new_code": "JIND",
    "label": "Jind",
    "rank": 198,
    "name_hi": "जींद",
    "local_name": "जींद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567480099_633.jpg"
  },
  "kaithal": {
    "value": "HR_KT",
    "new_code": "KAITHAL",
    "label": "Kaithal",
    "rank": 199,
    "name_hi": "कैथल",
    "local_name": "कैथल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567463363_777.jpg"
  },
  "karnal": {
    "value": "HR_KR",
    "new_code": "KARNAL",
    "label": "Karnal",
    "rank": 200,
    "name_hi": "करनाल",
    "local_name": "करनाल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567466772_864.jpg"
  },
  "kurukshetra": {
    "value": "HR_KU",
    "new_code": "KURUKSHETRA",
    "label": "Kurukshetra",
    "rank": 201,
    "name_hi": "कुरुक्षेत्र",
    "local_name": "कुरुक्षेत्र",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567482653_878.jpg"
  },
  "mahendragarh": {
    "value": "HR_MA",
    "new_code": "MAHENDRAGARH",
    "label": "Mahendragarh",
    "rank": 202,
    "name_hi": "महेंद्रगढ़",
    "local_name": "महेंद्रगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567492306_664.jpg"
  },
  "nuh": {
    "value": "HR_MW",
    "new_code": "NUH",
    "label": "Nuh",
    "rank": 203,
    "name_hi": "nuh",
    "local_name": "नूह",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567466104_767.jpg"
  },
  "palwal": {
    "value": "HR_PW",
    "new_code": "PALWAL",
    "label": "Palwal",
    "rank": 204,
    "name_hi": "पलवल",
    "local_name": "पलवल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567474111_555.jpg"
  },
  "panchkula": {
    "value": "HR_PK",
    "new_code": "PANCHKULA",
    "label": "Panchkula",
    "rank": 205,
    "name_hi": "पंचकुला",
    "local_name": "पंचकूला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567496440_886.jpg"
  },
  "panipat": {
    "value": "HR_PP",
    "new_code": "PANIPAT",
    "label": "Panipat",
    "rank": 206,
    "name_hi": "पानीपत",
    "local_name": "पानीपत",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567471033_425.jpg"
  },
  "rewari": {
    "value": "HR_RE",
    "new_code": "REWARI",
    "label": "Rewari",
    "rank": 207,
    "name_hi": "रेवाड़ी",
    "local_name": "रेवाड़ी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567468884_811.jpg"
  },
  "rohtak": {
    "value": "HR_RO",
    "new_code": "ROHTAK",
    "label": "Rohtak",
    "rank": 208,
    "name_hi": "रोहतक",
    "local_name": "रोहतक",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567478750_549.jpg"
  },
  "sirsa": {
    "value": "HR_SI",
    "new_code": "SIRSA",
    "label": "Sirsa",
    "rank": 209,
    "name_hi": "सिरसा",
    "local_name": "सिरसा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567471706_349.jpg"
  },
  "sonipat": {
    "value": "HR_SNP",
    "new_code": "SONIPAT",
    "label": "Sonipat",
    "rank": 210,
    "name_hi": "सोनीपत",
    "local_name": "सोनीपत",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567493235_367.jpg"
  },
  "yamuna-nagar": {
    "value": "HR_YN",
    "new_code": "YAMUNA_NAGAR",
    "label": "Yamuna Nagar",
    "rank": 211,
    "name_hi": "यमुनानगर",
    "local_name": "यमुना नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567495167_519.jpg"
  },
  "chamba": {
    "value": "HP_CH",
    "new_code": "CHAMBA",
    "label": "Chamba",
    "rank": 213,
    "name_hi": "चंबा",
    "local_name": "चंबा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577106824_201.jpg"
  },
  "hamirpur": {
    "value": "UP_HM",
    "new_code": "HAMIRPUR",
    "label": "Hamirpur",
    "rank": 649,
    "name_hi": "हमीरपुर",
    "local_name": "हमीरपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573711704_3.jpg"
  },
  "kangra": {
    "value": "HP_KA",
    "new_code": "KANGRA",
    "label": "Kangra",
    "rank": 215,
    "name_hi": "कांगड़ा",
    "local_name": "कांगड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567420658_354.jpg"
  },
  "kinnaur": {
    "value": "HP_KI",
    "new_code": "KINNAUR",
    "label": "Kinnaur",
    "rank": 216,
    "name_hi": "किन्नौर",
    "local_name": "किन्नौर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567454168_256.jpg"
  },
  "kullu": {
    "value": "HP_KU",
    "new_code": "KULLU",
    "label": "Kullu",
    "rank": 217,
    "name_hi": "कुल्लू",
    "local_name": "कुल्लू",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567459347_764.jpg"
  },
  "lahul-and-spiti": {
    "value": "HP_LS",
    "new_code": "LAHUL_AND_SPITI",
    "label": "Lahul And Spiti",
    "rank": 218,
    "name_hi": "लाहौल और स्पीति",
    "local_name": "लाहौल और स्पीति",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567462124_301.jpg"
  },
  "mandi": {
    "value": "HP_MA",
    "new_code": "MANDI",
    "label": "Mandi",
    "rank": 219,
    "name_hi": "मंडी",
    "local_name": "मंडी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567460600_772.jpg"
  },
  "shimla": {
    "value": "HP_SH",
    "new_code": "SHIMLA",
    "label": "Shimla",
    "rank": 220,
    "name_hi": "शिमला",
    "local_name": "शिमला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567455800_937.jpg"
  },
  "sirmaur": {
    "value": "HP_SI",
    "new_code": "SIRMAUR",
    "label": "Sirmaur",
    "rank": 221,
    "name_hi": "सिरमौर",
    "local_name": "सिरमौर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567457294_231.jpg"
  },
  "solan": {
    "value": "HP_SO",
    "new_code": "SOLAN",
    "label": "Solan",
    "rank": 222,
    "name_hi": "सोलन",
    "local_name": "सोलन",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567453170_566.jpg"
  },
  "una": {
    "value": "HP_UNA",
    "new_code": "UNA",
    "label": "Una",
    "rank": 223,
    "name_hi": "ऊना",
    "local_name": "ऊना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577144221_946.jpg"
  },
  "anantnag": {
    "value": "JK_AN",
    "new_code": "ANANTNAG",
    "label": "Anantnag",
    "rank": 224,
    "name_hi": "अनंतनाग",
    "local_name": "अनंतनाग"
  },
  "bandipore": {
    "value": "JK_BPR",
    "new_code": "BANDIPORE",
    "label": "Bandipore",
    "rank": 225,
    "name_hi": "बांदीपुरा",
    "local_name": "बांदीपुरा"
  },
  "baramula": {
    "value": "JK_BR",
    "new_code": "BARAMULA",
    "label": "Baramula",
    "rank": 226,
    "name_hi": "बारामूला",
    "local_name": "बारामूला"
  },
  "badgam": {
    "value": "JK_BD",
    "new_code": "BADGAM",
    "label": "Badgam",
    "rank": 227,
    "name_hi": "बड़गाम",
    "local_name": "बड़गाम"
  },
  "doda": {
    "value": "JK_DO",
    "new_code": "DODA",
    "label": "Doda",
    "rank": 228,
    "name_hi": "डोडा",
    "local_name": "डोडा"
  },
  "ganderbal": {
    "value": "JK_GB",
    "new_code": "GANDERBAL",
    "label": "Ganderbal",
    "rank": 229,
    "name_hi": "गांदरबल",
    "local_name": "गांदरबल"
  },
  "jammu": {
    "value": "JK_JA",
    "new_code": "JAMMU",
    "label": "Jammu",
    "rank": 230,
    "name_hi": "जम्मू",
    "local_name": "जम्मू"
  },
  "kargil": {
    "value": "LK_KR",
    "new_code": "KARGIL",
    "label": "Kargil",
    "rank": 231,
    "name_hi": "कारगिल",
    "local_name": "कारगिल"
  },
  "kathua": {
    "value": "JK_KT",
    "new_code": "KATHUA",
    "label": "Kathua",
    "rank": 232,
    "name_hi": "कठुआ",
    "local_name": "कठुआ"
  },
  "kishtwar": {
    "value": "JK_KW",
    "new_code": "KISHTWAR",
    "label": "Kishtwar",
    "rank": 233,
    "name_hi": "किश्तवाड़",
    "local_name": "किश्तवाड़"
  },
  "kulgam": {
    "value": "JK_KG",
    "new_code": "KULGAM",
    "label": "Kulgam",
    "rank": 234,
    "name_hi": "कुलगाम",
    "local_name": "कुलगाम"
  },
  "kupwara": {
    "value": "JK_KU",
    "new_code": "KUPWARA",
    "label": "Kupwara",
    "rank": 235,
    "name_hi": "कुपवाड़ा",
    "local_name": "कुपवाड़ा"
  },
  "leh-ladakh": {
    "value": "LK_LE",
    "new_code": "LEH_LADAKH",
    "label": "Leh Ladakh",
    "rank": 236,
    "name_hi": "लेह",
    "local_name": "लेह"
  },
  "punch": {
    "value": "JK_PO",
    "new_code": "PUNCH",
    "label": "Punch",
    "rank": 237,
    "name_hi": "पूंछ",
    "local_name": "पूंछ"
  },
  "pulwama": {
    "value": "JK_PU",
    "new_code": "PULWAMA",
    "label": "Pulwama",
    "rank": 238,
    "name_hi": "पुलवामा",
    "local_name": "पुलवामा"
  },
  "rajouri": {
    "value": "JK_RA",
    "new_code": "RAJOURI",
    "label": "Rajouri",
    "rank": 239,
    "name_hi": "राजौरी",
    "local_name": "राजौरी"
  },
  "ramban": {
    "value": "JK_RB",
    "new_code": "RAMBAN",
    "label": "Ramban",
    "rank": 240,
    "name_hi": "रामबन",
    "local_name": "रामबन"
  },
  "reasi": {
    "value": "JK_RS",
    "new_code": "REASI",
    "label": "Reasi",
    "rank": 241,
    "name_hi": "रियासी",
    "local_name": "रियासी"
  },
  "samba": {
    "value": "JK_SB",
    "new_code": "SAMBA",
    "label": "Samba",
    "rank": 242,
    "name_hi": "सांबा",
    "local_name": "सांबा"
  },
  "shupiyan": {
    "value": "JK_SH",
    "new_code": "SHUPIYAN",
    "label": "Shupiyan",
    "rank": 243,
    "name_hi": "शोपियां",
    "local_name": "शोपियां"
  },
  "srinagar": {
    "value": "JK_SR",
    "new_code": "SRINAGAR",
    "label": "Srinagar",
    "rank": 244,
    "name_hi": "श्रीनगर",
    "local_name": "श्रीनगर"
  },
  "udhampur": {
    "value": "JK_UD",
    "new_code": "UDHAMPUR",
    "label": "Udhampur",
    "rank": 245,
    "name_hi": "उधमपुर",
    "local_name": "उधमपुर"
  },
  "bokaro": {
    "value": "JH_BO",
    "new_code": "BOKARO",
    "label": "Bokaro",
    "rank": 246,
    "name_hi": "बोकारो",
    "local_name": "बोकारो",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571683302_0.jpg"
  },
  "chatra": {
    "value": "JH_CH",
    "new_code": "CHATRA",
    "label": "Chatra",
    "rank": 247,
    "name_hi": "चतरा",
    "local_name": "चतरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567500031_311.jpg"
  },
  "deoghar": {
    "value": "JH_DE",
    "new_code": "DEOGHAR",
    "label": "Deoghar",
    "rank": 248,
    "name_hi": "देवघर",
    "local_name": "देवघर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567497405_746.jpg"
  },
  "dhanbad": {
    "value": "JH_DH",
    "new_code": "DHANBAD",
    "label": "Dhanbad",
    "rank": 249,
    "name_hi": "धनबाद",
    "local_name": "धनबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571684598_212.jpg"
  },
  "dumka": {
    "value": "JH_DU",
    "new_code": "DUMKA",
    "label": "Dumka",
    "rank": 250,
    "name_hi": "दुमका",
    "local_name": "दुमका",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567498491_297.jpg"
  },
  "purbi-singhbhum": {
    "value": "JH_ES",
    "new_code": "PURBI_SINGHBHUM",
    "label": "Purbi Singhbhum",
    "rank": 251,
    "name_hi": "पूर्वी सिंहभूम",
    "local_name": "पूर्वी सिंहभूम",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567499147_598.jpg"
  },
  "garhwa": {
    "value": "JH_GA",
    "new_code": "GARHWA",
    "label": "Garhwa",
    "rank": 252,
    "name_hi": "गढ़वा",
    "local_name": "गढ़वा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571687344_824.jpg"
  },
  "giridih": {
    "value": "JH_GI",
    "new_code": "GIRIDIH",
    "label": "Giridih",
    "rank": 253,
    "name_hi": "गिरिडीह",
    "local_name": "गिरिडीह",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571692318_61.jpg"
  },
  "godda": {
    "value": "JH_GO",
    "new_code": "GODDA",
    "label": "Godda",
    "rank": 254,
    "name_hi": "गोड्डा",
    "local_name": "गोड्डा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571689917_743.jpg"
  },
  "gumla": {
    "value": "JH_GU",
    "new_code": "GUMLA",
    "label": "Gumla",
    "rank": 255,
    "name_hi": "गुमला",
    "local_name": "गुमला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567500770_852.jpg"
  },
  "hazaribagh": {
    "value": "JH_HA",
    "new_code": "HAZARIBAGH",
    "label": "Hazaribagh",
    "rank": 256,
    "name_hi": "हजारीबाग",
    "local_name": "हजारीबाग",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571693634_13.jpg"
  },
  "jamtara": {
    "value": "JH_JA",
    "new_code": "JAMTARA",
    "label": "Jamtara",
    "rank": 257,
    "name_hi": "जामताड़ा",
    "local_name": "जामताड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567502831_444.jpg"
  },
  "khunti": {
    "value": "JH_KH",
    "new_code": "KHUNTI",
    "label": "Khunti",
    "rank": 258,
    "name_hi": "खूंटी",
    "local_name": "खूंटी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571691118_310.jpg"
  },
  "kodarma": {
    "value": "JH_KO",
    "new_code": "KODARMA",
    "label": "Kodarma",
    "rank": 259,
    "name_hi": "कोडरमा",
    "local_name": "कोडरमा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571682551_929.jpg"
  },
  "latehar": {
    "value": "JH_LA",
    "new_code": "LATEHAR",
    "label": "Latehar",
    "rank": 260,
    "name_hi": "लातेहार",
    "local_name": "लातेहार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571686171_19.jpg"
  },
  "lohardaga": {
    "value": "JH_LO",
    "new_code": "LOHARDAGA",
    "label": "Lohardaga",
    "rank": 261,
    "name_hi": "लोहरदगा",
    "local_name": "लोहरदगा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567501756_972.jpg"
  },
  "pakur": {
    "value": "JH_PK",
    "new_code": "PAKUR",
    "label": "Pakur",
    "rank": 262,
    "name_hi": "पाकुर",
    "local_name": "पाकुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571691741_543.jpg"
  },
  "palamu": {
    "value": "JH_PL",
    "new_code": "PALAMU",
    "label": "Palamu",
    "rank": 263,
    "name_hi": "पलामू",
    "local_name": "पलामू",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571695054_328.jpg"
  },
  "ramgarh": {
    "value": "JH_RM",
    "new_code": "RAMGARH",
    "label": "Ramgarh",
    "rank": 264,
    "name_hi": "रामगढ़",
    "local_name": "रामगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571695754_39.jpg"
  },
  "ranchi": {
    "value": "JH_RA",
    "new_code": "RANCHI",
    "label": "Ranchi",
    "rank": 265,
    "name_hi": "रांची",
    "local_name": "राँची",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571693004_148.jpg"
  },
  "sahibganj": {
    "value": "JH_SA",
    "new_code": "SAHIBGANJ",
    "label": "Sahibganj",
    "rank": 266,
    "name_hi": "साहिबगंज",
    "local_name": "साहिबगंज",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571686844_151.jpg"
  },
  "saraikela-kharsawan": {
    "value": "JH_SK",
    "new_code": "SARAIKELA_KHARSAWAN",
    "label": "Saraikela Kharsawan",
    "rank": 267,
    "name_hi": "सिराइकेला खरसावां",
    "local_name": "सिराइकेला खरसावां",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571683938_653.jpg"
  },
  "simdega": {
    "value": "JH_SI",
    "new_code": "SIMDEGA",
    "label": "Simdega",
    "rank": 268,
    "name_hi": "सिमडेगा",
    "local_name": "सिमडेगा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571694310_716.jpg"
  },
  "pashchimi-singhbhum": {
    "value": "JH_WS",
    "new_code": "PASHCHIMI_SINGHBHUM",
    "label": "Pashchimi Singhbhum",
    "rank": 269,
    "name_hi": "पश्चिम सिंहभूम",
    "local_name": "पश्चिम सिंहभूम",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571689436_352.jpg"
  },
  "bagalkot": {
    "value": "KA_BK",
    "new_code": "BAGALKOT",
    "label": "Bagalkot",
    "rank": 270,
    "name_hi": "बागलकोट",
    "local_name": "ಬಾಗಲಕೋಟೆ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577263499_300.jpg"
  },
  "ballari": {
    "value": "KA_BL",
    "new_code": "BALLARI",
    "label": "Ballari",
    "rank": 271,
    "name_hi": "बल्लारी",
    "local_name": "ಬಳ್ಳಾರಿ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571699320_947.jpg"
  },
  "belagavi": {
    "value": "KA_BG",
    "new_code": "BELAGAVI",
    "label": "Belagavi",
    "rank": 272,
    "name_hi": "बेलगावी",
    "local_name": "ಬೆಳಗಾವಿ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571772630_616.jpg"
  },
  "bengaluru-rural": {
    "value": "KA_BR",
    "new_code": "BENGALURU_RURAL",
    "label": "Bengaluru Rural",
    "rank": 273,
    "name_hi": "बेंगलुरु ग्रामीण",
    "local_name": "ಬೆಂಗಳೂರು ಗ್ರಾಮೀಣ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571899003_914.jpg"
  },
  "bengaluru-urban": {
    "value": "KA_BN",
    "new_code": "BENGALURU_URBAN",
    "label": "Bengaluru Urban",
    "rank": 274,
    "name_hi": "बेंगलुरु शहरी",
    "local_name": "ಬೆಂಗಳೂರು ನಗರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577461754_872.jpg"
  },
  "bidar": {
    "value": "KA_BD",
    "new_code": "BIDAR",
    "label": "Bidar",
    "rank": 275,
    "name_hi": "बीदर",
    "local_name": "ಬೀದರ್",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571698680_767.jpg"
  },
  "chamarajnagar": {
    "value": "KA_CJ",
    "new_code": "CHAMARAJNAGAR",
    "label": "Chamarajnagar",
    "rank": 276,
    "name_hi": "चामराजनगर",
    "local_name": "ಚಾಮರಾಜನಗರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571770078_185.jpg"
  },
  "chikkaballapur": {
    "value": "KA_CK",
    "new_code": "CHIKKABALLAPUR",
    "label": "Chikkaballapur",
    "rank": 277,
    "name_hi": "चिक्कामगलुरु",
    "local_name": "ಚಿಕ್ಕಬಳ್ಳಾಪುರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577407888_462.jpg"
  },
  "chikkamagaluru": {
    "value": "KA_CM",
    "new_code": "CHIKKAMAGALURU",
    "label": "Chikkamagaluru",
    "rank": 278,
    "name_hi": "चिक्कामगलुरु",
    "local_name": "ಚಿಕ್ಕಮಗಳೂರು",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571738267_486.jpg"
  },
  "chitradurga": {
    "value": "KA_CT",
    "new_code": "CHITRADURGA",
    "label": "Chitradurga",
    "rank": 279,
    "name_hi": "चित्रदुर्ग",
    "local_name": "ಚಿತ್ರದುರ್ಗ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571739087_78.jpg"
  },
  "dakshina-kannada": {
    "value": "KA_DK",
    "new_code": "DAKSHINA_KANNADA",
    "label": "Dakshina Kannada",
    "rank": 280,
    "name_hi": "दक्षिणा कन्नड़",
    "local_name": "ದಕ್ಷಿಣ ಕನ್ನಡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571895967_853.jpg"
  },
  "davanagere": {
    "value": "KA_DA",
    "new_code": "DAVANAGERE",
    "label": "Davanagere",
    "rank": 281,
    "name_hi": "दावनगेरे",
    "local_name": "ದಾವಣಗೆರೆ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571896768_665.jpg"
  },
  "dharwad": {
    "value": "KA_DH",
    "new_code": "DHARWAD",
    "label": "Dharwad",
    "rank": 282,
    "name_hi": "धारवाड़",
    "local_name": "ಧಾರವಾಡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577164035_694.jpg"
  },
  "gadag": {
    "value": "KA_GA",
    "new_code": "GADAG",
    "label": "Gadag",
    "rank": 283,
    "name_hi": "गडग",
    "local_name": "ಗದಗ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571732150_681.jpg"
  },
  "hassan": {
    "value": "KA_HS",
    "new_code": "HASSAN",
    "label": "Hassan",
    "rank": 284,
    "name_hi": "हसन",
    "local_name": "ಹಾಸನ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571735847_895.jpg"
  },
  "haveri": {
    "value": "KA_HV",
    "new_code": "HAVERI",
    "label": "Haveri",
    "rank": 285,
    "name_hi": "हावेरी",
    "local_name": "ಹಾವೇರಿ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571734908_334.jpg"
  },
  "kalaburagi": {
    "value": "KA_GU",
    "new_code": "KALABURAGI",
    "label": "Kalaburagi",
    "rank": 286,
    "name_hi": "कालाबुरागी",
    "local_name": "ಕಲ್ಬರ್ಗಿ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577340684_168.jpg"
  },
  "kodagu": {
    "value": "KA_KD",
    "new_code": "KODAGU",
    "label": "Kodagu",
    "rank": 287,
    "name_hi": "कोडागू",
    "local_name": "ಕೊಡಗು",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571771229_463.jpg"
  },
  "kolar": {
    "value": "KA_KL",
    "new_code": "KOLAR",
    "label": "Kolar",
    "rank": 288,
    "name_hi": "कोलार",
    "local_name": "ಕೋಲಾರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571696420_172.jpg"
  },
  "koppal": {
    "value": "KA_KP",
    "new_code": "KOPPAL",
    "label": "Koppal",
    "rank": 289,
    "name_hi": "कोप्पल",
    "local_name": "ಕೊಪ್ಪಳ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577369618_634.jpg"
  },
  "mandya": {
    "value": "KA_MA",
    "new_code": "MANDYA",
    "label": "Mandya",
    "rank": 290,
    "name_hi": "मंड्या",
    "local_name": "ಮಂಡ್ಯ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571803527_965.jpg"
  },
  "mysuru": {
    "value": "KA_MY",
    "new_code": "MYSURU",
    "label": "Mysuru",
    "rank": 291,
    "name_hi": "मैसूर",
    "local_name": "ಮೈಸೂರು",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571897439_56.jpg"
  },
  "raichur": {
    "value": "KA_RA",
    "new_code": "RAICHUR",
    "label": "Raichur",
    "rank": 292,
    "name_hi": "रायचूर",
    "local_name": "ರಾಯಚೂರು",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571731101_500.jpg"
  },
  "ramanagara": {
    "value": "KA_RM",
    "new_code": "RAMANAGARA",
    "label": "Ramanagara",
    "rank": 293,
    "name_hi": "रामनगर",
    "local_name": "ರಾಮನಗರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571733993_887.jpg"
  },
  "shimoga": {
    "value": "KA_SH",
    "new_code": "SHIMOGA",
    "label": "Shimoga",
    "rank": 294,
    "name_hi": "शिवमोगा",
    "local_name": "ಶಿವಮೊಗ್ಗ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571898311_880.jpg"
  },
  "tumakuru": {
    "value": "KA_TU",
    "new_code": "TUMAKURU",
    "label": "Tumakuru",
    "rank": 295,
    "name_hi": "तुमाकुरु",
    "local_name": "ತುಮಕೂರು",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571697891_969.jpg"
  },
  "udupi": {
    "value": "KA_UD",
    "new_code": "UDUPI",
    "label": "Udupi",
    "rank": 296,
    "name_hi": "उडुपी",
    "local_name": "ಉಡುಪಿ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571733252_71.jpg"
  },
  "uttara-kannada": {
    "value": "KA_UK",
    "new_code": "UTTARA_KANNADA",
    "label": "Uttara Kannada",
    "rank": 297,
    "name_hi": "उत्तरा कन्नड़",
    "local_name": "ಉತ್ತರ ಕನ್ನಡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571737245_575.jpg"
  },
  "vijayapura": {
    "value": "KA_BJ",
    "new_code": "VIJAYAPURA",
    "label": "Vijayapura",
    "rank": 298,
    "name_hi": "विजयपुरा",
    "local_name": "ವಿಜಯಪುರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571736501_91.jpg"
  },
  "yadgir": {
    "value": "KA_YG",
    "new_code": "YADGIR",
    "label": "Yadgir",
    "rank": 299,
    "name_hi": "यादगीर",
    "local_name": "ಯಾದಗಿರಿ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571865084_470.jpg"
  },
  "alappuzha": {
    "value": "KL_AL",
    "new_code": "ALAPPUZHA",
    "label": "Alappuzha",
    "rank": 300,
    "name_hi": "अलाप्पुझा",
    "local_name": "ആലപ്പുഴ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571942700_723.jpg"
  },
  "ernakulam": {
    "value": "KL_ER",
    "new_code": "ERNAKULAM",
    "label": "Ernakulam",
    "rank": 301,
    "name_hi": "एर्नाकुलम",
    "local_name": "എറണാകുളം",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752571939594_795.webp"
  },
  "idukki": {
    "value": "KL_ID",
    "new_code": "IDUKKI",
    "label": "Idukki",
    "rank": 302,
    "name_hi": "इडुक्की",
    "local_name": "ഇടുക്കി",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571941120_236.jpg"
  },
  "kannur": {
    "value": "KL_KN",
    "new_code": "KANNUR",
    "label": "Kannur",
    "rank": 303,
    "name_hi": "कन्नूर",
    "local_name": "കണ്ണൂർ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571933685_938.jpg"
  },
  "kasaragod": {
    "value": "KL_KS",
    "new_code": "KASARAGOD",
    "label": "Kasaragod",
    "rank": 304,
    "name_hi": "कासरगोड",
    "local_name": "കാസർഗോഡ്",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571932764_784.jpg"
  },
  "kollam": {
    "value": "KL_KL",
    "new_code": "KOLLAM",
    "label": "Kollam",
    "rank": 305,
    "name_hi": "कोल्लम",
    "local_name": "കൊല്ലം",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571938106_34.jpg"
  },
  "kottayam": {
    "value": "KL_KT",
    "new_code": "KOTTAYAM",
    "label": "Kottayam",
    "rank": 306,
    "name_hi": "कोट्टायम",
    "local_name": "കോട്ടയം",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571941900_58.jpg"
  },
  "kozhikode": {
    "value": "KL_KZ",
    "new_code": "KOZHIKODE",
    "label": "Kozhikode",
    "rank": 307,
    "name_hi": "कोझिकोड",
    "local_name": "കോഴിക്കോട്",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571934601_173.jpg"
  },
  "malappuram": {
    "value": "KL_MA",
    "new_code": "MALAPPURAM",
    "label": "Malappuram",
    "rank": 308,
    "name_hi": "मलप्पुरम",
    "local_name": "മലപ്പുറം",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577487177_261.jpg"
  },
  "palakkad": {
    "value": "KL_PL",
    "new_code": "PALAKKAD",
    "label": "Palakkad",
    "rank": 309,
    "name_hi": "पलक्कड़",
    "local_name": "പാലക്കാട്",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571935253_20.jpg"
  },
  "pathanamthitta": {
    "value": "KL_PT",
    "new_code": "PATHANAMTHITTA",
    "label": "Pathanamthitta",
    "rank": 310,
    "name_hi": "पथानामथिट्टा",
    "local_name": "പത്തനംതിട്ട",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571930031_842.jpg"
  },
  "thrissur": {
    "value": "KL_TS",
    "new_code": "THRISSUR",
    "label": "Thrissur",
    "rank": 311,
    "name_hi": "त्रिशूर",
    "local_name": "തൃശൂർ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571936561_464.jpg"
  },
  "thiruvananthapuram": {
    "value": "KL_TV",
    "new_code": "THIRUVANANTHAPURAM",
    "label": "Thiruvananthapuram",
    "rank": 312,
    "name_hi": "तिरुवनंतपुरम",
    "local_name": "തിരുവനന്തപുരം",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752571945587_376.webp"
  },
  "wayanad": {
    "value": "KL_WA",
    "new_code": "WAYANAD",
    "label": "Wayanad",
    "rank": 313,
    "name_hi": "वायनाड",
    "local_name": "വയനാട്",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571938812_274.jpg"
  },
  "lakshadweep": {
    "value": "LD_LD",
    "new_code": "LAKSHADWEEP",
    "label": "Lakshadweep",
    "rank": 314,
    "name_hi": "लक्षद्वीप",
    "local_name": "लक्षद्वीप"
  },
  "agar-malwa": {
    "value": "MP_AG",
    "new_code": "AGAR_MALWA",
    "label": "Agar Malwa",
    "rank": 315,
    "name_hi": "आगर मालवा",
    "local_name": "आगर मालवा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572175370_25.webp"
  },
  "alirajpur": {
    "value": "MP_AL",
    "new_code": "ALIRAJPUR",
    "label": "Alirajpur",
    "rank": 316,
    "name_hi": "अलीराजपुर",
    "local_name": "अलीराजपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572257183_940.jpg"
  },
  "anuppur": {
    "value": "MP_AP",
    "new_code": "ANUPPUR",
    "label": "Anuppur",
    "rank": 317,
    "name_hi": "अनूपपुर",
    "local_name": "अनूपपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572283930_757.jpg"
  },
  "ashok-nagar": {
    "value": "MP_AS",
    "new_code": "ASHOK_NAGAR",
    "label": "Ashok Nagar",
    "rank": 318,
    "name_hi": "अशोक नगर",
    "local_name": "अशोक नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572169797_221.jpg"
  },
  "balaghat": {
    "value": "MP_BL",
    "new_code": "BALAGHAT",
    "label": "Balaghat",
    "rank": 319,
    "name_hi": "बालाघाट",
    "local_name": "बालाघाट",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572280001_461.webp"
  },
  "barwani": {
    "value": "MP_BR",
    "new_code": "BARWANI",
    "label": "Barwani",
    "rank": 320,
    "name_hi": "बड़वानी",
    "local_name": "बड़वानी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572278887_173.jpg"
  },
  "betul": {
    "value": "MP_BE",
    "new_code": "BETUL",
    "label": "Betul",
    "rank": 321,
    "name_hi": "बेतुल",
    "local_name": "बैतूल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572171792_148.jpg"
  },
  "bhind": {
    "value": "MP_BD",
    "new_code": "BHIND",
    "label": "Bhind",
    "rank": 322,
    "name_hi": "भिंड",
    "local_name": "भिंड",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572222951_969.webp"
  },
  "bhopal": {
    "value": "MP_BP",
    "new_code": "BHOPAL",
    "label": "Bhopal",
    "rank": 323,
    "name_hi": "भोपाल",
    "local_name": "भोपाल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571578905_574.jpg"
  },
  "burhanpur": {
    "value": "MP_BU",
    "new_code": "BURHANPUR",
    "label": "Burhanpur",
    "rank": 324,
    "name_hi": "बुरहानपुर",
    "local_name": "बुरहानपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572174711_985.jpg"
  },
  "chhatarpur": {
    "value": "MP_CT",
    "new_code": "CHHATARPUR",
    "label": "Chhatarpur",
    "rank": 325,
    "name_hi": "छतरपुर",
    "local_name": "छतरपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572221064_437.jpg"
  },
  "chhindwara": {
    "value": "MP_CN",
    "new_code": "CHHINDWARA",
    "label": "Chhindwara",
    "rank": 326,
    "name_hi": "छिंदवाड़ा",
    "local_name": "छिंदवाड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572171026_493.jpg"
  },
  "damoh": {
    "value": "MP_DM",
    "new_code": "DAMOH",
    "label": "Damoh",
    "rank": 327,
    "name_hi": "दमोह",
    "local_name": "दमोह",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572270265_894.jpg"
  },
  "datia": {
    "value": "MP_DT",
    "new_code": "DATIA",
    "label": "Datia",
    "rank": 328,
    "name_hi": "दतिया",
    "local_name": "दतिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572138687_747.jpg"
  },
  "dewas": {
    "value": "MP_DE",
    "new_code": "DEWAS",
    "label": "Dewas",
    "rank": 329,
    "name_hi": "देवास",
    "local_name": "देवास",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577727293_843.jpg"
  },
  "dhar": {
    "value": "MP_DH",
    "new_code": "DHAR",
    "label": "Dhar",
    "rank": 330,
    "name_hi": "धार",
    "local_name": "धार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572208477_6.jpg"
  },
  "dindori": {
    "value": "MP_DI",
    "new_code": "DINDORI",
    "label": "Dindori",
    "rank": 331,
    "name_hi": "डिंडोरी",
    "local_name": "डिंडौरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572215906_811.jpg"
  },
  "guna": {
    "value": "MP_GU",
    "new_code": "GUNA",
    "label": "Guna",
    "rank": 332,
    "name_hi": "गुना",
    "local_name": "गुना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577742344_280.jpg"
  },
  "gwalior": {
    "value": "MP_GW",
    "new_code": "GWALIOR",
    "label": "Gwalior",
    "rank": 333,
    "name_hi": "ग्वालियर",
    "local_name": "ग्वालियर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572219803_37.jpg"
  },
  "harda": {
    "value": "MP_HA",
    "new_code": "HARDA",
    "label": "Harda",
    "rank": 334,
    "name_hi": "हरदा",
    "local_name": "हरदा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572266472_113.jpg"
  },
  "hoshangabad": {
    "value": "MP_HO",
    "new_code": "HOSHANGABAD",
    "label": "Hoshangabad",
    "rank": 335,
    "name_hi": "होशंगाबाद",
    "local_name": "होशंगाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572218535_732.jpg"
  },
  "indore": {
    "value": "MP_IN",
    "new_code": "INDORE",
    "label": "Indore",
    "rank": 336,
    "name_hi": "इंदौर",
    "local_name": "इंदौर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572258621_571.jpg"
  },
  "jabalpur": {
    "value": "MP_JA",
    "new_code": "JABALPUR",
    "label": "Jabalpur",
    "rank": 337,
    "name_hi": "जबलपुर",
    "local_name": "जबलपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572272403_783.jpg"
  },
  "jhabua": {
    "value": "MP_JH",
    "new_code": "JHABUA",
    "label": "Jhabua",
    "rank": 338,
    "name_hi": "झाबुआ",
    "local_name": "झाबुआ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572276753_485.jpg"
  },
  "katni": {
    "value": "MP_KA",
    "new_code": "KATNI",
    "label": "Katni",
    "rank": 339,
    "name_hi": "कटनी",
    "local_name": "कटनी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572257907_845.jpg"
  },
  "khandwa": {
    "value": "MP_EN",
    "new_code": "KHANDWA",
    "label": "Khandwa",
    "rank": 340,
    "name_hi": "खंडवा",
    "local_name": "खंडवा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572260432_901.jpg"
  },
  "khargone-west-nimar": {
    "value": "MP_WN",
    "new_code": "KHARGONE_(_WEST_NIMAR)",
    "label": "Khargone (West Nimar)",
    "rank": 341,
    "name_hi": "खरगोन (पश्चिम निमाड़)",
    "local_name": "खरगोन (पश्चिम निमाड़)",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572286807_334.jpg"
  },
  "mandla": {
    "value": "MP_ML",
    "new_code": "MANDLA",
    "label": "Mandla",
    "rank": 342,
    "name_hi": "मंडला",
    "local_name": "मंडला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572284965_620.jpg"
  },
  "mandsaur": {
    "value": "MP_MS",
    "new_code": "MANDSAUR",
    "label": "Mandsaur",
    "rank": 343,
    "name_hi": "मंदसौर",
    "local_name": "मंदसौर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572217978_919.jpg"
  },
  "morena": {
    "value": "MP_MO",
    "new_code": "MORENA",
    "label": "Morena",
    "rank": 344,
    "name_hi": "मोरेना",
    "local_name": "मुरैना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572287983_798.jpg"
  },
  "narsinghpur": {
    "value": "MP_NA",
    "new_code": "NARSINGHPUR",
    "label": "Narsinghpur",
    "rank": 345,
    "name_hi": "नरसिंहपुर",
    "local_name": "नरसिंहपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572289868_638.jpg"
  },
  "neemuch": {
    "value": "MP_NE",
    "new_code": "NEEMUCH",
    "label": "Neemuch",
    "rank": 346,
    "name_hi": "नीमच",
    "local_name": "नीमच",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572217332_816.jpg"
  },
  "niwari": {
    "value": "MP_NW",
    "new_code": "NIWARI",
    "label": "Niwari",
    "rank": 347,
    "name_hi": "निवारी",
    "local_name": "निवाड़ी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572259888_58.jpg"
  },
  "panna": {
    "value": "MP_PA",
    "new_code": "PANNA",
    "label": "Panna",
    "rank": 348,
    "name_hi": "पन्ना",
    "local_name": "पन्ना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572263158_82.jpg"
  },
  "raisen": {
    "value": "MP_RS",
    "new_code": "RAISEN",
    "label": "Raisen",
    "rank": 349,
    "name_hi": "रायसेन",
    "local_name": "रायसेन",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572173138_821.webp"
  },
  "rajgarh": {
    "value": "MP_RG",
    "new_code": "RAJGARH",
    "label": "Rajgarh",
    "rank": 350,
    "name_hi": "राजगढ़",
    "local_name": "राजगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572265669_765.jpg"
  },
  "ratlam": {
    "value": "MP_RL",
    "new_code": "RATLAM",
    "label": "Ratlam",
    "rank": 351,
    "name_hi": "रतलाम",
    "local_name": "रतलाम",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572224294_468.jpg"
  },
  "rewa": {
    "value": "MP_RE",
    "new_code": "REWA",
    "label": "Rewa",
    "rank": 352,
    "name_hi": "रीवा",
    "local_name": "रीवा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572170455_164.jpg"
  },
  "sagar": {
    "value": "MP_SG",
    "new_code": "SAGAR",
    "label": "Sagar",
    "rank": 353,
    "name_hi": "सागर",
    "local_name": "सागर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572222331_502.jpg"
  },
  "satna": {
    "value": "MP_ST",
    "new_code": "SATNA",
    "label": "Satna",
    "rank": 354,
    "name_hi": "सतना",
    "local_name": "सतना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572213994_921.jpg"
  },
  "sehore": {
    "value": "MP_SR",
    "new_code": "SEHORE",
    "label": "Sehore",
    "rank": 355,
    "name_hi": "सीहोर",
    "local_name": "सीहोर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572275779_487.jpg"
  },
  "seoni": {
    "value": "MP_SO",
    "new_code": "SEONI",
    "label": "Seoni",
    "rank": 356,
    "name_hi": "सिवनी",
    "local_name": "सिवनी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572267293_567.jpg"
  },
  "shahdol": {
    "value": "MP_SH",
    "new_code": "SHAHDOL",
    "label": "Shahdol",
    "rank": 357,
    "name_hi": "शाहडोल",
    "local_name": "शहडोल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572263922_158.jpg"
  },
  "shajapur": {
    "value": "MP_SJ",
    "new_code": "SHAJAPUR",
    "label": "Shajapur",
    "rank": 358,
    "name_hi": "शाजापुर",
    "local_name": "शाजापुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572219225_935.jpg"
  },
  "sheopur": {
    "value": "MP_SP",
    "new_code": "SHEOPUR",
    "label": "Sheopur",
    "rank": 359,
    "name_hi": "श्योपुर",
    "local_name": "श्योपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572216494_964.jpg"
  },
  "shivpuri": {
    "value": "MP_SV",
    "new_code": "SHIVPURI",
    "label": "Shivpuri",
    "rank": 360,
    "name_hi": "शिवपुरी",
    "local_name": "शिवपुरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572215301_402.jpg"
  },
  "sidhi": {
    "value": "MP_SI",
    "new_code": "SIDHI",
    "label": "Sidhi",
    "rank": 361,
    "name_hi": "सीधी",
    "local_name": "सीधी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572221711_824.jpg"
  },
  "singrauli": {
    "value": "MP_SN",
    "new_code": "SINGRAULI",
    "label": "Singrauli",
    "rank": 362,
    "name_hi": "सिंगरौली",
    "local_name": "सिंगरौली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572259267_328.jpg"
  },
  "tikamgarh": {
    "value": "MP_TI",
    "new_code": "TIKAMGARH",
    "label": "Tikamgarh",
    "rank": 363,
    "name_hi": "टीकमगढ़",
    "local_name": "टीकमगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572214616_479.jpg"
  },
  "ujjain": {
    "value": "MP_UJ",
    "new_code": "UJJAIN",
    "label": "Ujjain",
    "rank": 364,
    "name_hi": "उज्जैन",
    "local_name": "उज्जैन",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572177343_504.webp"
  },
  "umaria": {
    "value": "MP_UM",
    "new_code": "UMARIA",
    "label": "Umaria",
    "rank": 365,
    "name_hi": "उमरिया",
    "local_name": "उमरिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572172395_944.jpg"
  },
  "vidisha": {
    "value": "MP_VI",
    "new_code": "VIDISHA",
    "label": "Vidisha",
    "rank": 366,
    "name_hi": "विदिशा",
    "local_name": "विदिशा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572176232_812.jpg"
  },
  "ahmednagar": {
    "value": "MH_AH",
    "new_code": "AHMEDNAGAR",
    "label": "Ahmednagar",
    "rank": 367,
    "name_hi": "अहमदनगर",
    "local_name": "अहमदनगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572133708_51.jpg"
  },
  "akola": {
    "value": "MH_AK",
    "new_code": "AKOLA",
    "label": "Akola",
    "rank": 368,
    "name_hi": "अकोला",
    "local_name": "अकोला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571987123_252.jpg"
  },
  "amravati": {
    "value": "MH_AM",
    "new_code": "AMRAVATI",
    "label": "Amravati",
    "rank": 369,
    "name_hi": "अमरावती",
    "local_name": "अमरावती",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571985020_845.jpg"
  },
  "chhatrapati-sambhajinagar": {
    "value": "MH_AU",
    "new_code": "CHHATRAPATI_SAMBHAJINAGAR",
    "label": "Chhatrapati Sambhajinagar",
    "rank": 370,
    "name_hi": "छत्रपति संभाजीनगर",
    "local_name": "छत्रपती संभाजीनगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572065958_120.jpg"
  },
  "beed": {
    "value": "MH_BI",
    "new_code": "BEED",
    "label": "Beed",
    "rank": 371,
    "name_hi": "बीड",
    "local_name": "बीड",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572072835_746.jpg"
  },
  "bhandara": {
    "value": "MH_BH",
    "new_code": "BHANDARA",
    "label": "Bhandara",
    "rank": 372,
    "name_hi": "भंडारा",
    "local_name": "भंडारा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571947472_541.jpg"
  },
  "buldhana": {
    "value": "MH_BU",
    "new_code": "BULDHANA",
    "label": "Buldhana",
    "rank": 373,
    "name_hi": "बुलढाना",
    "local_name": "बुलढाणा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571985750_397.jpg"
  },
  "chandrapur": {
    "value": "MH_CH",
    "new_code": "CHANDRAPUR",
    "label": "Chandrapur",
    "rank": 374,
    "name_hi": "चंद्रपुर",
    "local_name": "चंद्रपूर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572062528_546.jpg"
  },
  "dhule": {
    "value": "MH_DH",
    "new_code": "DHULE",
    "label": "Dhule",
    "rank": 375,
    "name_hi": "धुले",
    "local_name": "धुळे",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572136680_513.jpg"
  },
  "gadchiroli": {
    "value": "MH_GA",
    "new_code": "GADCHIROLI",
    "label": "Gadchiroli",
    "rank": 376,
    "name_hi": "गडचिरोली",
    "local_name": "गडचिरोली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571950402_789.jpg"
  },
  "gondia": {
    "value": "MH_GO",
    "new_code": "GONDIA",
    "label": "Gondia",
    "rank": 377,
    "name_hi": "गोंदिया",
    "local_name": "गोंदिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572069860_45.jpg"
  },
  "hingoli": {
    "value": "MH_HI",
    "new_code": "HINGOLI",
    "label": "Hingoli",
    "rank": 378,
    "name_hi": "हिंगोली",
    "local_name": "हिंगोली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572070528_674.jpg"
  },
  "jalgaon": {
    "value": "MH_JG",
    "new_code": "JALGAON",
    "label": "Jalgaon",
    "rank": 379,
    "name_hi": "जलगांव",
    "local_name": "जळगाव",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572059733_303.jpg"
  },
  "jalna": {
    "value": "MH_JN",
    "new_code": "JALNA",
    "label": "Jalna",
    "rank": 380,
    "name_hi": "जलना",
    "local_name": "जालना",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571952752_673.jpg"
  },
  "kolhapur": {
    "value": "MH_KO",
    "new_code": "KOLHAPUR",
    "label": "Kolhapur",
    "rank": 381,
    "name_hi": "कोल्हापुर",
    "local_name": "कोल्हापूर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572059096_328.jpg"
  },
  "latur": {
    "value": "MH_LA",
    "new_code": "LATUR",
    "label": "Latur",
    "rank": 382,
    "name_hi": "लातूर",
    "local_name": "लातूर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572136113_492.jpg"
  },
  "mumbai-city": {
    "value": "MH_MC",
    "new_code": "MUMBAI_CITY",
    "label": "Mumbai City",
    "rank": 383,
    "name_hi": "मुंबई शहर",
    "local_name": "मुंबई _सिटी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571989504_199.jpg"
  },
  "mumbai-suburban": {
    "value": "MH_MU",
    "new_code": "MUMBAI_SUBURBAN",
    "label": "Mumbai suburban",
    "rank": 384,
    "name_hi": "मुंबई उपनगरीय",
    "local_name": "मुंबई उपनगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571951275_213.jpg"
  },
  "nanded": {
    "value": "MH_ND",
    "new_code": "NANDED",
    "label": "Nanded",
    "rank": 385,
    "name_hi": "नांदेड़",
    "local_name": "नांदेड",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577666084_394.jpg"
  },
  "nandurbar": {
    "value": "MH_NB",
    "new_code": "NANDURBAR",
    "label": "Nandurbar",
    "rank": 386,
    "name_hi": "नंदुरबार",
    "local_name": "नंदुरबार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572069042_504.jpg"
  },
  "nagpur": {
    "value": "MH_NG",
    "new_code": "NAGPUR",
    "label": "Nagpur",
    "rank": 387,
    "name_hi": "नागपुर",
    "local_name": "नागपूर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572137868_634.webp"
  },
  "nashik": {
    "value": "MH_NS",
    "new_code": "NASHIK",
    "label": "Nashik",
    "rank": 388,
    "name_hi": "नासिक",
    "local_name": "नाशिक",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577554677_484.jpg"
  },
  "dharavshiv": {
    "value": "MH_OS",
    "new_code": "DHARAVSHIV",
    "label": "Dharavshiv",
    "rank": 389,
    "name_hi": "धाराशिव",
    "local_name": "धाराशिव",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572071485_947.jpg"
  },
  "palghar": {
    "value": "MH_PG",
    "new_code": "PALGHAR",
    "label": "Palghar",
    "rank": 390,
    "name_hi": "पालघर",
    "local_name": "पालघर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572054826_749.jpg"
  },
  "parbhani": {
    "value": "MH_PA",
    "new_code": "PARBHANI",
    "label": "Parbhani",
    "rank": 391,
    "name_hi": "परभनी",
    "local_name": "परभणी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577504863_199.jpg"
  },
  "pune": {
    "value": "MH_PU",
    "new_code": "PUNE",
    "label": "Pune",
    "rank": 392,
    "name_hi": "पुणे",
    "local_name": "पुणे",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571986467_250.jpg"
  },
  "raigad": {
    "value": "MH_RG",
    "new_code": "RAIGAD",
    "label": "Raigad",
    "rank": 393,
    "name_hi": "रायगढ़",
    "local_name": "रायगड",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572066668_812.jpg"
  },
  "ratnagiri": {
    "value": "MH_RT",
    "new_code": "RATNAGIRI",
    "label": "Ratnagiri",
    "rank": 394,
    "name_hi": "रत्नागिरी",
    "local_name": "रत्नागिरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572067424_568.jpg"
  },
  "sangli": {
    "value": "MH_SN",
    "new_code": "SANGLI",
    "label": "Sangli",
    "rank": 395,
    "name_hi": "सांगली",
    "local_name": "सांगली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577709455_998.jpg"
  },
  "satara": {
    "value": "MH_ST",
    "new_code": "SATARA",
    "label": "Satara",
    "rank": 396,
    "name_hi": "सतारा",
    "local_name": "सातारा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572058103_789.jpg"
  },
  "sindhudurg": {
    "value": "MH_SI",
    "new_code": "SINDHUDURG",
    "label": "Sindhudurg",
    "rank": 397,
    "name_hi": "सिंधुदुर्ग",
    "local_name": "सिंधुदुर्ग",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572061825_296.jpg"
  },
  "solapur": {
    "value": "MH_SO",
    "new_code": "SOLAPUR",
    "label": "Solapur",
    "rank": 398,
    "name_hi": "सोलापुर",
    "local_name": "सोलापूर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571951994_975.jpg"
  },
  "thane": {
    "value": "MH_TH",
    "new_code": "THANE",
    "label": "Thane",
    "rank": 399,
    "name_hi": "थाइन",
    "local_name": "ठाणे",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577642718_812.jpg"
  },
  "wardha": {
    "value": "MH_WR",
    "new_code": "WARDHA",
    "label": "Wardha",
    "rank": 400,
    "name_hi": "वर्धा",
    "local_name": "वर्धा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572020327_487.jpg"
  },
  "washim": {
    "value": "MH_WS",
    "new_code": "WASHIM",
    "label": "Washim",
    "rank": 401,
    "name_hi": "वाशिम",
    "local_name": "वाशीम",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571948630_697.jpg"
  },
  "yavatmal": {
    "value": "MH_YA",
    "new_code": "YAVATMAL",
    "label": "Yavatmal",
    "rank": 402,
    "name_hi": "यवतमाल",
    "local_name": "यवतमाळ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572022836_447.webp"
  },
  "bishnupur": {
    "value": "MN_BI",
    "new_code": "BISHNUPUR",
    "label": "Bishnupur",
    "rank": 403,
    "name_hi": "बिश्नुपुर",
    "local_name": "बिश्नुपुर"
  },
  "thoubal": {
    "value": "MN_TH",
    "new_code": "THOUBAL",
    "label": "Thoubal",
    "rank": 404,
    "name_hi": "थौबल",
    "local_name": "थौबल"
  },
  "imphal-east": {
    "value": "MN_EI",
    "new_code": "IMPHAL_EAST",
    "label": "Imphal East",
    "rank": 405,
    "name_hi": "इम्फाल पूर्व",
    "local_name": "इम्फाल पूर्व"
  },
  "imphal-west": {
    "value": "MN_WI",
    "new_code": "IMPHAL_WEST",
    "label": "Imphal West",
    "rank": 406,
    "name_hi": "इम्फाल पश्चिम",
    "local_name": "इम्फाल पश्चिम"
  },
  "senapati": {
    "value": "MN_SE",
    "new_code": "SENAPATI",
    "label": "Senapati",
    "rank": 407,
    "name_hi": "सेनापति",
    "local_name": "सेनापति"
  },
  "ukhrul": {
    "value": "MN_UK",
    "new_code": "UKHRUL",
    "label": "Ukhrul",
    "rank": 408,
    "name_hi": "उखरूल",
    "local_name": "उखरूल"
  },
  "chandel": {
    "value": "MN_CD",
    "new_code": "CHANDEL",
    "label": "Chandel",
    "rank": 409,
    "name_hi": "चंदेल",
    "local_name": "चंदेल"
  },
  "churachandpur": {
    "value": "MN_CC",
    "new_code": "CHURACHANDPUR",
    "label": "Churachandpur",
    "rank": 410,
    "name_hi": "छुरछंदपुर",
    "local_name": "छुरछंदपुर"
  },
  "tamenglong": {
    "value": "MN_TA",
    "new_code": "TAMENGLONG",
    "label": "Tamenglong",
    "rank": 411,
    "name_hi": "तामेंगलांग",
    "local_name": "तामेंगलांग"
  },
  "jirabam": {
    "value": "MN_JB",
    "new_code": "JIRABAM",
    "label": "Jirabam",
    "rank": 412,
    "name_hi": "नोनी",
    "local_name": "नोनी"
  },
  "kangpokpi": {
    "value": "MN_KPI",
    "new_code": "KANGPOKPI",
    "label": "Kangpokpi",
    "rank": 413,
    "name_hi": "कांगपोकपी (सदर हिल्स)",
    "local_name": "कांगपोकपी (सदर हिल्स)"
  },
  "kakching": {
    "value": "MN_KAK",
    "new_code": "KAKCHING",
    "label": "Kakching",
    "rank": 414,
    "name_hi": "काकचिंग",
    "local_name": "काकचिंग"
  },
  "tengnoupal": {
    "value": "MN_TN",
    "new_code": "TENGNOUPAL",
    "label": "Tengnoupal",
    "rank": 415,
    "name_hi": "",
    "local_name": ""
  },
  "kamjong": {
    "value": "MN_KJ",
    "new_code": "KAMJONG",
    "label": "Kamjong",
    "rank": 416,
    "name_hi": "",
    "local_name": ""
  },
  "noney": {
    "value": "MN_NN",
    "new_code": "NONEY",
    "label": "Noney",
    "rank": 417,
    "name_hi": "",
    "local_name": ""
  },
  "pherzawl": {
    "value": "MN_PZ",
    "new_code": "PHERZAWL",
    "label": "Pherzawl",
    "rank": 418,
    "name_hi": "फेरजॉल",
    "local_name": "फेरजॉल"
  },
  "east-garo-hills": {
    "value": "ML_EG",
    "new_code": "EAST_GARO_HILLS",
    "label": "East Garo Hills",
    "rank": 419,
    "name_hi": "ईस्ट गारो हिल्स",
    "local_name": "ईस्ट गारो हिल्स"
  },
  "east-khasi-hills": {
    "value": "ML_EK",
    "new_code": "EAST_KHASI_HILLS",
    "label": "East Khasi Hills",
    "rank": 420,
    "name_hi": "पूर्वी खासी हिल्स",
    "local_name": "पूर्वी खासी हिल्स"
  },
  "jaintia-hills": {
    "value": "ML_EJH",
    "new_code": "JAINTIA_HILLS",
    "label": "Jaintia Hills",
    "rank": 421,
    "name_hi": "दक्षिण पश्चिम खासी हिल्स",
    "local_name": "दक्षिण पश्चिम खासी हिल्स"
  },
  "north-garo-hills": {
    "value": "ML_NGH",
    "new_code": "NORTH_GARO_HILLS",
    "label": "North Garo Hills",
    "rank": 422,
    "name_hi": "",
    "local_name": ""
  },
  "ribhoi": {
    "value": "ML_RB",
    "new_code": "RIBHOI",
    "label": "Ribhoi",
    "rank": 423,
    "name_hi": "री भोई",
    "local_name": "री भोई"
  },
  "south-garo-hills": {
    "value": "ML_SG",
    "new_code": "SOUTH_GARO_HILLS",
    "label": "South Garo Hills",
    "rank": 424,
    "name_hi": "दक्षिण गारो हिल्स",
    "local_name": "दक्षिण गारो हिल्स"
  },
  "south-west-garo-hills": {
    "value": "ML_SWGH",
    "new_code": "SOUTH_WEST_GARO_HILLS",
    "label": "South West Garo Hills",
    "rank": 425,
    "name_hi": "",
    "local_name": ""
  },
  "south-west-khasi-hills": {
    "value": "ML_SWKH",
    "new_code": "SOUTH_WEST_KHASI_HILLS",
    "label": "South West Khasi Hills",
    "rank": 426,
    "name_hi": "",
    "local_name": ""
  },
  "west-jaintia-hills": {
    "value": "ML_WJ",
    "new_code": "WEST_JAINTIA_HILLS",
    "label": "West Jaintia Hills",
    "rank": 427,
    "name_hi": "वेस्ट जैंतिया हिल्स",
    "local_name": "वेस्ट जैंतिया हिल्स"
  },
  "west-garo-hills": {
    "value": "ML_WG",
    "new_code": "WEST_GARO_HILLS",
    "label": "West Garo Hills",
    "rank": 428,
    "name_hi": "वेस्ट गारो हिल्स",
    "local_name": "वेस्ट गारो हिल्स"
  },
  "west-khasi-hills": {
    "value": "ML_WK",
    "new_code": "WEST_KHASI_HILLS",
    "label": "West Khasi Hills",
    "rank": 429,
    "name_hi": "पश्चिम खासी हिल्स",
    "local_name": "पश्चिम खासी हिल्स"
  },
  "aizawl": {
    "value": "MZ_AI",
    "new_code": "AIZAWL",
    "label": "Aizawl",
    "rank": 430,
    "name_hi": "आइजोल",
    "local_name": "आइजोल"
  },
  "champhai": {
    "value": "MZ_CH",
    "new_code": "CHAMPHAI",
    "label": "Champhai",
    "rank": 431,
    "name_hi": "चम्फाई",
    "local_name": "चम्फाई"
  },
  "kolasib": {
    "value": "MZ_KO",
    "new_code": "KOLASIB",
    "label": "Kolasib",
    "rank": 432,
    "name_hi": "कोलासिब",
    "local_name": "कोलासिब"
  },
  "lawngtlai": {
    "value": "MZ_LA",
    "new_code": "LAWNGTLAI",
    "label": "Lawngtlai",
    "rank": 433,
    "name_hi": "लन्गट्ली",
    "local_name": "लन्गट्ली"
  },
  "lunglei": {
    "value": "MZ_LU",
    "new_code": "LUNGLEI",
    "label": "Lunglei",
    "rank": 434,
    "name_hi": "लुंगलेई",
    "local_name": "लुंगलेई"
  },
  "mamit": {
    "value": "MZ_MA",
    "new_code": "MAMIT",
    "label": "Mamit",
    "rank": 435,
    "name_hi": "मामित",
    "local_name": "मामित"
  },
  "saiha": {
    "value": "MZ_SA",
    "new_code": "SAIHA",
    "label": "Saiha",
    "rank": 436,
    "name_hi": "सैहा",
    "local_name": "सैहा"
  },
  "serchhip": {
    "value": "MZ_SE",
    "new_code": "SERCHHIP",
    "label": "Serchhip",
    "rank": 437,
    "name_hi": "सेरछिप",
    "local_name": "सेरछिप"
  },
  "dimapur": {
    "value": "NL_DI",
    "new_code": "DIMAPUR",
    "label": "Dimapur",
    "rank": 438,
    "name_hi": "दीमापुर",
    "local_name": "दीमापुर"
  },
  "kiphire": {
    "value": "NL_KI",
    "new_code": "KIPHIRE",
    "label": "Kiphire",
    "rank": 439,
    "name_hi": "किफायर",
    "local_name": "किफायर"
  },
  "kohima": {
    "value": "NL_KO",
    "new_code": "KOHIMA",
    "label": "Kohima",
    "rank": 440,
    "name_hi": "कोहिमा",
    "local_name": "कोहिमा"
  },
  "longleng": {
    "value": "NL_LO",
    "new_code": "LONGLENG",
    "label": "Longleng",
    "rank": 441,
    "name_hi": "लोंगलेंग",
    "local_name": "लोंगलेंग"
  },
  "mokokchung": {
    "value": "NL_MK",
    "new_code": "MOKOKCHUNG",
    "label": "Mokokchung",
    "rank": 442,
    "name_hi": "मोकोकचुंग",
    "local_name": "मोकोकचुंग"
  },
  "mon": {
    "value": "NL_MN",
    "new_code": "MON",
    "label": "Mon",
    "rank": 443,
    "name_hi": "सोम",
    "local_name": "सोम"
  },
  "noklak": {
    "value": "NL_NL",
    "new_code": "NOKLAK",
    "label": "Noklak",
    "rank": 444,
    "name_hi": "नोक्लाक",
    "local_name": "नोक्लाक"
  },
  "peren": {
    "value": "NL_PE",
    "new_code": "PEREN",
    "label": "Peren",
    "rank": 445,
    "name_hi": "पेरेन",
    "local_name": "पेरेन"
  },
  "phek": {
    "value": "NL_PH",
    "new_code": "PHEK",
    "label": "Phek",
    "rank": 446,
    "name_hi": "फेक",
    "local_name": "फेक"
  },
  "tuensang": {
    "value": "NL_TU",
    "new_code": "TUENSANG",
    "label": "Tuensang",
    "rank": 447,
    "name_hi": "तुएनसांग",
    "local_name": "तुएनसांग"
  },
  "wokha": {
    "value": "NL_WO",
    "new_code": "WOKHA",
    "label": "Wokha",
    "rank": 448,
    "name_hi": "वोखा",
    "local_name": "वोखा"
  },
  "zunheboto": {
    "value": "NL_ZU",
    "new_code": "ZUNHEBOTO",
    "label": "Zunheboto",
    "rank": 449,
    "name_hi": "जुन्हेबोटो",
    "local_name": "जुन्हेबोटो"
  },
  "angul": {
    "value": "OD_AN",
    "new_code": "ANGUL",
    "label": "Angul",
    "rank": 450,
    "name_hi": "अंगुल",
    "local_name": "ଅନୁଗୋଳ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577848824_560.jpg"
  },
  "boudh-bauda": {
    "value": "OD_BD",
    "new_code": "BOUDH_(_BAUDA)",
    "label": "Boudh (Bauda)",
    "rank": 451,
    "name_hi": "बौध (बौडा)",
    "local_name": "ବୌଦ୍ଧ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572482188_154.jpg"
  },
  "bhadrak": {
    "value": "OD_BH",
    "new_code": "BHADRAK",
    "label": "Bhadrak",
    "rank": 452,
    "name_hi": "भद्रक",
    "local_name": "ଭଦ୍ରକ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571274887_712.jpg"
  },
  "balangir": {
    "value": "OD_BL",
    "new_code": "BALANGIR",
    "label": "Balangir",
    "rank": 453,
    "name_hi": "बलांगीर",
    "local_name": "ବଲାଙ୍ଗୀର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577784827_168.jpg"
  },
  "bargarh-baragarh": {
    "value": "OD_BR",
    "new_code": "BARGARH_(_BARAGARH)",
    "label": "Bargarh (Baragarh)",
    "rank": 454,
    "name_hi": "बरगढ़ (बैरागढ़)",
    "local_name": "ବରଗଡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572525100_301.jpg"
  },
  "balasore": {
    "value": "OD_BW",
    "new_code": "BALASORE",
    "label": "Balasore",
    "rank": 455,
    "name_hi": "बालासोर",
    "local_name": "ବାଲେଶ୍ୱର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572522260_549.jpg"
  },
  "cuttack": {
    "value": "OD_CU",
    "new_code": "CUTTACK",
    "label": "Cuttack",
    "rank": 456,
    "name_hi": "कटक",
    "local_name": "କଟକ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572385517_502.webp"
  },
  "debagarh-deogarh": {
    "value": "OD_DE",
    "new_code": "DEBAGARH_(_DEOGARH)",
    "label": "Debagarh (Deogarh)",
    "rank": 457,
    "name_hi": "देवगढ़ (देवगढ़)",
    "local_name": "ଦେବଗଡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572290893_364.jpg"
  },
  "dhenkanal": {
    "value": "OD_DH",
    "new_code": "DHENKANAL",
    "label": "Dhenkanal",
    "rank": 458,
    "name_hi": "ढेंकनाल",
    "local_name": "ଢେଙ୍କାନାଳ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572294549_474.jpg"
  },
  "ganjam": {
    "value": "OD_GN",
    "new_code": "GANJAM",
    "label": "Ganjam",
    "rank": 459,
    "name_hi": "गंजम",
    "local_name": "ଗଞ୍ଜାମ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571276388_459.jpg"
  },
  "gajapati": {
    "value": "OD_GP",
    "new_code": "GAJAPATI",
    "label": "Gajapati",
    "rank": 460,
    "name_hi": "गजपति",
    "local_name": "ଗଜପତି",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572450255_602.jpg"
  },
  "jharsuguda": {
    "value": "OD_JH",
    "new_code": "JHARSUGUDA",
    "label": "Jharsuguda",
    "rank": 461,
    "name_hi": "झारसुगुडा",
    "local_name": "ଝାରସୁଗୁଡା",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572519601_212.jpg"
  },
  "jajpur": {
    "value": "OD_JP",
    "new_code": "JAJPUR",
    "label": "Jajpur",
    "rank": 462,
    "name_hi": "जाजपुर",
    "local_name": "ଯାଜପୁର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572387062_204.jpg"
  },
  "jagatsinghpur": {
    "value": "OD_JS",
    "new_code": "JAGATSINGHPUR",
    "label": "Jagatsinghpur",
    "rank": 463,
    "name_hi": "जगतसिंहपुर",
    "local_name": "ଜଗତସିଂହପୁର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572293726_564.jpg"
  },
  "khordha": {
    "value": "OD_KH",
    "new_code": "KHORDHA",
    "label": "Khordha",
    "rank": 464,
    "name_hi": "खोर्धा",
    "local_name": "ଖୋର୍ଦ୍ଧା",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577942028_711.jpg"
  },
  "kendujhar": {
    "value": "OD_KJ",
    "new_code": "KENDUJHAR",
    "label": "Kendujhar",
    "rank": 465,
    "name_hi": "केंदुझर (क्योंझर)",
    "local_name": "କେନ୍ଦୁଝର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577887196_87.jpg"
  },
  "kalahandi": {
    "value": "OD_KL",
    "new_code": "KALAHANDI",
    "label": "Kalahandi",
    "rank": 466,
    "name_hi": "कालाहांडी",
    "local_name": "କଳାହାଣ୍ଡି",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572527762_4.jpg"
  },
  "kandhamal": {
    "value": "OD_KN",
    "new_code": "KANDHAMAL",
    "label": "Kandhamal",
    "rank": 467,
    "name_hi": "कंधमाल",
    "local_name": "କନ୍ଧମାଳ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577871920_792.jpg"
  },
  "koraput": {
    "value": "OD_KO",
    "new_code": "KORAPUT",
    "label": "Koraput",
    "rank": 468,
    "name_hi": "कोरापुट",
    "local_name": "କୋରାପୁଟ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572484255_411.jpg"
  },
  "kendrapara": {
    "value": "OD_KP",
    "new_code": "KENDRAPARA",
    "label": "Kendrapara",
    "rank": 469,
    "name_hi": "केंद्रपाड़ा",
    "local_name": "କେନ୍ଦ୍ରାପଡା",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572520208_82.jpg"
  },
  "malkangiri": {
    "value": "OD_ML",
    "new_code": "MALKANGIRI",
    "label": "Malkangiri",
    "rank": 470,
    "name_hi": "मल्कानगिरी",
    "local_name": "ମାଲକାନଗିରି",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572486351_497.jpg"
  },
  "mayurbhanj": {
    "value": "OD_MY",
    "new_code": "MAYURBHANJ",
    "label": "Mayurbhanj",
    "rank": 471,
    "name_hi": "मयूरभंज",
    "local_name": "ମୟୂରଭଞ୍ଜ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572484966_572.webp"
  },
  "nabarangpur": {
    "value": "OD_NB",
    "new_code": "NABARANGPUR",
    "label": "Nabarangpur",
    "rank": 472,
    "name_hi": "नबरंगपुर",
    "local_name": "ନବରଙ୍ଗପୁର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577918477_252.jpg"
  },
  "nuapada": {
    "value": "OD_NU",
    "new_code": "NUAPADA",
    "label": "Nuapada",
    "rank": 473,
    "name_hi": "नुआपाड़ा",
    "local_name": "ନୂଆପଡା",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577765277_738.jpg"
  },
  "nayagarh": {
    "value": "OD_NY",
    "new_code": "NAYAGARH",
    "label": "Nayagarh",
    "rank": 474,
    "name_hi": "नयागढ़",
    "local_name": "ନୟାଗଡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577827432_273.jpg"
  },
  "puri": {
    "value": "OD_PU",
    "new_code": "PURI",
    "label": "Puri",
    "rank": 475,
    "name_hi": "पुरी",
    "local_name": "ପୁରୀ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572387697_655.jpg"
  },
  "rayagada": {
    "value": "OD_RA",
    "new_code": "RAYAGADA",
    "label": "Rayagada",
    "rank": 476,
    "name_hi": "रायगढ़",
    "local_name": "ରାୟଗଡା",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572518670_340.jpg"
  },
  "sambalpur": {
    "value": "OD_SA",
    "new_code": "SAMBALPUR",
    "label": "Sambalpur",
    "rank": 477,
    "name_hi": "संबलपुर",
    "local_name": "ସମ୍ବଲପୁର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572526743_304.jpg"
  },
  "subarnapur-sonepur": {
    "value": "OD_SO",
    "new_code": "SUBARNAPUR_(_SONEPUR)",
    "label": "Subarnapur (Sonepur)",
    "rank": 478,
    "name_hi": "सुबरनपुर (सोनीपुर)",
    "local_name": "ସୁବର୍ଣ୍ଣପୁର",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572291483_747.webp"
  },
  "sundargarh": {
    "value": "OD_SU",
    "new_code": "SUNDARGARH",
    "label": "Sundargarh",
    "rank": 479,
    "name_hi": "सुंदरगढ़",
    "local_name": "ସୁନ୍ଦରଗଡ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572525782_553.jpg"
  },
  "karaikal": {
    "value": "PY_KA",
    "new_code": "KARAIKAL",
    "label": "Karaikal",
    "rank": 480,
    "name_hi": "कराईकल",
    "local_name": "कराईकल"
  },
  "mahe": {
    "value": "PY_MA",
    "new_code": "MAHE",
    "label": "Mahe",
    "rank": 481,
    "name_hi": "माहे",
    "local_name": "माहे"
  },
  "puducherry": {
    "value": "PY_PO",
    "new_code": "PUDUCHERRY",
    "label": "Puducherry",
    "rank": 482,
    "name_hi": "पांडिचेरी",
    "local_name": "पांडिचेरी"
  },
  "yanam": {
    "value": "PY_YA",
    "new_code": "YANAM",
    "label": "Yanam",
    "rank": 483,
    "name_hi": "यानम",
    "local_name": "यानम"
  },
  "amritsar": {
    "value": "PB_AM",
    "new_code": "AMRITSAR",
    "label": "Amritsar",
    "rank": 484,
    "name_hi": "अमृतसर",
    "local_name": "ਅੰਮ੍ਰਿਤਸਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572598702_252.webp"
  },
  "barnala": {
    "value": "PB_BNL",
    "new_code": "BARNALA",
    "label": "Barnala",
    "rank": 485,
    "name_hi": "बरनाला",
    "local_name": "ਬਰਨਾਲਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572594497_118.webp"
  },
  "bathinda": {
    "value": "PB_BA",
    "new_code": "BATHINDA",
    "label": "Bathinda",
    "rank": 486,
    "name_hi": "बठिंडा",
    "local_name": "ਬਠਿੰਡਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572558923_533.jpg"
  },
  "firozpur": {
    "value": "PB_FI",
    "new_code": "FIROZPUR",
    "label": "Firozpur",
    "rank": 487,
    "name_hi": "फिरोजपुर",
    "local_name": "ਫ਼ਿਰੋਜ਼ਪੁਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572591989_502.jpg"
  },
  "faridkot": {
    "value": "PB_FR",
    "new_code": "FARIDKOT",
    "label": "Faridkot",
    "rank": 488,
    "name_hi": "फरीदकोट",
    "local_name": "ਫਰੀਦਕੋਟ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572592919_388.jpg"
  },
  "fatehgarh-sahib": {
    "value": "PB_FT",
    "new_code": "FATEHGARH_SAHIB",
    "label": "Fatehgarh Sahib",
    "rank": 489,
    "name_hi": "फतेहगढ़ साहिब",
    "local_name": "ਫਤਿਹਗੜ੍ਹ ਸਾਹਿਬ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577984057_734.jpg"
  },
  "fazilka": {
    "value": "PB_FA",
    "new_code": "FAZILKA",
    "label": "Fazilka",
    "rank": 490,
    "name_hi": "फाजिल्का",
    "local_name": "ਫਾਜ਼ਿਲਕਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572607432_767.jpg"
  },
  "gurdaspur": {
    "value": "PB_GU",
    "new_code": "GURDASPUR",
    "label": "Gurdaspur",
    "rank": 491,
    "name_hi": "गुरदासपुर",
    "local_name": "ਗੁਰਦਾਸਪੁਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572609603_86.jpg"
  },
  "hoshiarpur": {
    "value": "PB_HO",
    "new_code": "HOSHIARPUR",
    "label": "Hoshiarpur",
    "rank": 492,
    "name_hi": "होशियारपुर",
    "local_name": "ਹੁਸ਼ਿਆਰਪੁਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572613561_138.jpg"
  },
  "jalandhar": {
    "value": "PB_JA",
    "new_code": "JALANDHAR",
    "label": "Jalandhar",
    "rank": 493,
    "name_hi": "जालंधर",
    "local_name": "ਜਲੰਧਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572591242_771.jpg"
  },
  "kapurthala": {
    "value": "PB_KA",
    "new_code": "KAPURTHALA",
    "label": "Kapurthala",
    "rank": 494,
    "name_hi": "कपूरथला",
    "local_name": "ਕਪੂਰਥਲਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572603200_251.jpg"
  },
  "ludhiana": {
    "value": "PB_LU",
    "new_code": "LUDHIANA",
    "label": "Ludhiana",
    "rank": 495,
    "name_hi": "लुधियाना",
    "local_name": "ਲੁਧਿਆਣਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572610369_986.jpg"
  },
  "mansa": {
    "value": "PB_MA",
    "new_code": "MANSA",
    "label": "Mansa",
    "rank": 496,
    "name_hi": "मनसा",
    "local_name": "ਮਾਨਸਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572605394_423.webp"
  },
  "moga": {
    "value": "PB_MO",
    "new_code": "MOGA",
    "label": "Moga",
    "rank": 497,
    "name_hi": "मोगा",
    "local_name": "ਮੋਗਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572614363_394.jpg"
  },
  "muktsar": {
    "value": "PB_MU",
    "new_code": "MUKTSAR",
    "label": "Muktsar",
    "rank": 498,
    "name_hi": "श्री मुक्तसर साहिब",
    "local_name": "ਮੁਕਤਸਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572602567_744.jpg"
  },
  "pathankot": {
    "value": "PB_PAT",
    "new_code": "PATHANKOT",
    "label": "Pathankot",
    "rank": 499,
    "name_hi": "पठानकोट",
    "local_name": "ਪਠਾਨਕੋਟ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572609069_602.jpg"
  },
  "patiala": {
    "value": "PB_PA",
    "new_code": "PATIALA",
    "label": "Patiala",
    "rank": 500,
    "name_hi": "पटियाला",
    "local_name": "ਪਟਿਆਲਾ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572593637_677.jpg"
  },
  "rupnagar": {
    "value": "PB_RU",
    "new_code": "RUPNAGAR",
    "label": "Rupnagar",
    "rank": 501,
    "name_hi": "रूपनगर",
    "local_name": "ਰੂਪਨਗਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572611691_76.webp"
  },
  "sahibzada-ajit-singh-nagar": {
    "value": "PB_SAS",
    "new_code": "SAHIBZADA_AJIT_SINGH_NAGAR",
    "label": "Sahibzada Ajit Singh Nagar",
    "rank": 502,
    "name_hi": "साहिबजादा अजीत सिंह नगर",
    "local_name": "ਸਾਹਿਬਜ਼ਾਦਾ ਅਜੀਤ ਸਿੰਘ ਨਗਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752572597869_563.webp"
  },
  "sangrur": {
    "value": "PB_SA",
    "new_code": "SANGRUR",
    "label": "Sangrur",
    "rank": 503,
    "name_hi": "संगरूर",
    "local_name": "ਸੰਗਰੂਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572601895_324.jpg"
  },
  "shahid-bhagat-singh-nagar": {
    "value": "PB_PB",
    "new_code": "SHAHID_BHAGAT_SINGH_NAGAR",
    "label": "Shahid Bhagat Singh Nagar",
    "rank": 504,
    "name_hi": "शहीद भगत सिंह नगर",
    "local_name": "ਸ਼ਹੀਦ ਭਗਤ ਸਿੰਘ ਨਗਰ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572608089_317.jpg"
  },
  "tarn-taran": {
    "value": "PB_TT",
    "new_code": "TARN_TARAN",
    "label": "Tarn Taran",
    "rank": 505,
    "name_hi": "तरनतारन",
    "local_name": "ਤਰਨਤਾਰਨ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752572595695_135.jpg"
  },
  "ajmer": {
    "value": "RJ_AJ",
    "new_code": "AJMER",
    "label": "Ajmer",
    "rank": 506,
    "name_hi": "अजमेर",
    "local_name": "अजमेर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578098079_560.jpg"
  },
  "alwar": {
    "value": "RJ_AL",
    "new_code": "ALWAR",
    "label": "Alwar",
    "rank": 507,
    "name_hi": "अलवर",
    "local_name": "अलवर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578149452_939.jpg"
  },
  "bikaner": {
    "value": "RJ_BI",
    "new_code": "BIKANER",
    "label": "Bikaner",
    "rank": 508,
    "name_hi": "बीकानेर",
    "local_name": "बीकानेर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578250132_450.jpg"
  },
  "barmer": {
    "value": "RJ_BM",
    "new_code": "BARMER",
    "label": "Barmer",
    "rank": 509,
    "name_hi": "बाड़मेर",
    "local_name": "बाड़मेर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567151087_376.jpg"
  },
  "banswara": {
    "value": "RJ_BN",
    "new_code": "BANSWARA",
    "label": "Banswara",
    "rank": 510,
    "name_hi": "बांसवाड़ा",
    "local_name": "बांसवाड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567143304_7.jpg"
  },
  "bharatpur": {
    "value": "RJ_BP",
    "new_code": "BHARATPUR",
    "label": "Bharatpur",
    "rank": 511,
    "name_hi": "भरतपुर",
    "local_name": "भरतपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578274897_440.jpg"
  },
  "baran": {
    "value": "RJ_BR",
    "new_code": "BARAN",
    "label": "Baran",
    "rank": 512,
    "name_hi": "बरन",
    "local_name": "बारां",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578133240_783.jpg"
  },
  "bundi": {
    "value": "RJ_BU",
    "new_code": "BUNDI",
    "label": "Bundi",
    "rank": 513,
    "name_hi": "बूंदी",
    "local_name": "बूंदी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578166332_616.jpg"
  },
  "bhilwara": {
    "value": "RJ_BW",
    "new_code": "BHILWARA",
    "label": "Bhilwara",
    "rank": 514,
    "name_hi": "भीलवाड़ा",
    "local_name": "भीलवाड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567107172_351.jpg"
  },
  "churu": {
    "value": "RJ_CR",
    "new_code": "CHURU",
    "label": "Churu",
    "rank": 515,
    "name_hi": "चुरू",
    "local_name": "चुरू",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578200795_134.jpg"
  },
  "chittorgarh": {
    "value": "RJ_CT",
    "new_code": "CHITTORGARH",
    "label": "Chittorgarh",
    "rank": 516,
    "name_hi": "चित्तौड़गढ़",
    "local_name": "चित्तौड़गढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578003632_436.jpg"
  },
  "dausa": {
    "value": "RJ_DA",
    "new_code": "DAUSA",
    "label": "Dausa",
    "rank": 517,
    "name_hi": "दौसा",
    "local_name": "दौसा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578060209_886.jpg"
  },
  "dholpur": {
    "value": "RJ_DH",
    "new_code": "DHOLPUR",
    "label": "Dholpur",
    "rank": 518,
    "name_hi": "धौलपुर",
    "local_name": "धौलपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567248588_209.jpg"
  },
  "dungarpur": {
    "value": "RJ_DU",
    "new_code": "DUNGARPUR",
    "label": "Dungarpur",
    "rank": 519,
    "name_hi": "डूंगरपुर",
    "local_name": "डूंगरपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567149500_369.jpg"
  },
  "ganganagar": {
    "value": "RJ_GA",
    "new_code": "GANGANAGAR",
    "label": "Ganganagar",
    "rank": 520,
    "name_hi": "गंगानगर",
    "local_name": "गंगानगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567217209_360.jpg"
  },
  "hanumangarh": {
    "value": "RJ_HA",
    "new_code": "HANUMANGARH",
    "label": "Hanumangarh",
    "rank": 521,
    "name_hi": "हनुमानगढ़",
    "local_name": "हनुमानगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567183257_825.jpg"
  },
  "jhunjhunu": {
    "value": "RJ_JJ",
    "new_code": "JHUNJHUNU",
    "label": "Jhunjhunu",
    "rank": 522,
    "name_hi": "झुंझुनू",
    "local_name": "झुंझुनू",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578041859_43.jpg"
  },
  "jalor": {
    "value": "RJ_JL",
    "new_code": "JALOR",
    "label": "Jalor",
    "rank": 523,
    "name_hi": "जालोर",
    "local_name": "जालोर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567105096_31.jpg"
  },
  "jodhpur": {
    "value": "RJ_JO",
    "new_code": "JODHPUR",
    "label": "Jodhpur",
    "rank": 524,
    "name_hi": "जोधपुर",
    "local_name": "जोधपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567138992_965.webp"
  },
  "jaipur": {
    "value": "RJ_JP",
    "new_code": "JAIPUR",
    "label": "Jaipur",
    "rank": 525,
    "name_hi": "जयपुर",
    "local_name": "जयपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567216116_623.jpg"
  },
  "jaisalmer": {
    "value": "RJ_JS",
    "new_code": "JAISALMER",
    "label": "Jaisalmer",
    "rank": 526,
    "name_hi": "जैसलमेर",
    "local_name": "जैसलमेर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567106394_93.jpg"
  },
  "jhalawar": {
    "value": "RJ_JW",
    "new_code": "JHALAWAR",
    "label": "Jhalawar",
    "rank": 527,
    "name_hi": "झालावाड़",
    "local_name": "झालावाड़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578182884_486.jpg"
  },
  "karauli": {
    "value": "RJ_KA",
    "new_code": "KARAULI",
    "label": "Karauli",
    "rank": 528,
    "name_hi": "करौली",
    "local_name": "करौली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578218630_327.jpg"
  },
  "kota": {
    "value": "RJ_KO",
    "new_code": "KOTA",
    "label": "Kota",
    "rank": 529,
    "name_hi": "कोटा",
    "local_name": "कोटा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567148300_238.jpg"
  },
  "nagaur": {
    "value": "RJ_NA",
    "new_code": "NAGAUR",
    "label": "Nagaur",
    "rank": 530,
    "name_hi": "नागौर",
    "local_name": "नागौर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578116419_373.jpg"
  },
  "pali": {
    "value": "RJ_PA",
    "new_code": "PALI",
    "label": "Pali",
    "rank": 531,
    "name_hi": "पाली",
    "local_name": "पाली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567142538_850.jpg"
  },
  "pratapgarh": {
    "value": "UP_PR",
    "new_code": "PRATAPGARH",
    "label": "Pratapgarh",
    "rank": 675,
    "name_hi": "प्रतापगढ़",
    "local_name": "प्रतापगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573841534_800.jpg"
  },
  "rajsamand": {
    "value": "RJ_RA",
    "new_code": "RAJSAMAND",
    "label": "Rajsamand",
    "rank": 533,
    "name_hi": "राजसमंद",
    "local_name": "राजसमन्द",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578025427_778.jpg"
  },
  "sikar": {
    "value": "RJ_SK",
    "new_code": "SIKAR",
    "label": "Sikar",
    "rank": 534,
    "name_hi": "सीकर",
    "local_name": "सीकर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567182511_687.jpg"
  },
  "sawai-madhopur": {
    "value": "RJ_SM",
    "new_code": "SAWAI_MADHOPUR",
    "label": "Sawai Madhopur",
    "rank": 535,
    "name_hi": "सवाई माधोपुर",
    "local_name": "सवाई माधोपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752578233631_330.webp"
  },
  "sirohi": {
    "value": "RJ_SR",
    "new_code": "SIROHI",
    "label": "Sirohi",
    "rank": 536,
    "name_hi": "सिरोही",
    "local_name": "सिरोही",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567184735_927.webp"
  },
  "tonk": {
    "value": "RJ_TO",
    "new_code": "TONK",
    "label": "Tonk",
    "rank": 537,
    "name_hi": "टोंक",
    "local_name": "टोंक",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567138197_188.jpg"
  },
  "udaipur": {
    "value": "RJ_UD",
    "new_code": "UDAIPUR",
    "label": "Udaipur",
    "rank": 538,
    "name_hi": "उदयपुर",
    "local_name": "उदयपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567146421_825.jpg"
  },
  "east": {
    "value": "SK_ES",
    "new_code": "EAST",
    "label": "East",
    "rank": 539,
    "name_hi": "पूर्वी सिक्किम",
    "local_name": "पूर्वी सिक्किम"
  },
  "north": {
    "value": "SK_NS",
    "new_code": "NORTH",
    "label": "North",
    "rank": 540,
    "name_hi": "उत्तर सिक्किम",
    "local_name": "उत्तर सिक्किम"
  },
  "south": {
    "value": "SK_SS",
    "new_code": "SOUTH",
    "label": "South",
    "rank": 541,
    "name_hi": "दक्षिण सिक्किम",
    "local_name": "दक्षिण सिक्किम"
  },
  "west": {
    "value": "SK_WS",
    "new_code": "WEST",
    "label": "West",
    "rank": 542,
    "name_hi": "पश्चिम सिक्किम",
    "local_name": "पश्चिम सिक्किम"
  },
  "ariyalur": {
    "value": "TN_AY",
    "new_code": "ARIYALUR",
    "label": "Ariyalur",
    "rank": 543,
    "name_hi": "अरियालुर",
    "local_name": "அரியலூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578459293_580.jpg"
  },
  "chennai": {
    "value": "TN_CH",
    "new_code": "CHENNAI",
    "label": "Chennai",
    "rank": 544,
    "name_hi": "चेन्नई",
    "local_name": "சென்னை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578554749_259.jpg"
  },
  "coimbatore": {
    "value": "TN_CO",
    "new_code": "COIMBATORE",
    "label": "Coimbatore",
    "rank": 545,
    "name_hi": "कोयंबटूर",
    "local_name": "கோவை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567299028_524.jpg"
  },
  "cuddalore": {
    "value": "TN_CU",
    "new_code": "CUDDALORE",
    "label": "Cuddalore",
    "rank": 546,
    "name_hi": "कुड्डालोर",
    "local_name": "கடலூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567334349_454.jpg"
  },
  "dharmapuri": {
    "value": "TN_DH",
    "new_code": "DHARMAPURI",
    "label": "Dharmapuri",
    "rank": 547,
    "name_hi": "धर्मपुरी",
    "local_name": "தர்மபுரி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567264941_602.jpg"
  },
  "dindigul": {
    "value": "TN_DI",
    "new_code": "DINDIGUL",
    "label": "Dindigul",
    "rank": 548,
    "name_hi": "डिंडीगुल",
    "local_name": "திண்டுக்கல்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567335300_838.jpg"
  },
  "erode": {
    "value": "TN_ER",
    "new_code": "ERODE",
    "label": "Erode",
    "rank": 549,
    "name_hi": "इरोड",
    "local_name": "ஈரோடு",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752578319139_838.webp"
  },
  "kallakurichi": {
    "value": "TN_KL",
    "new_code": "KALLAKURICHI",
    "label": "Kallakurichi",
    "rank": 550,
    "name_hi": "कल्लाकुरिची",
    "local_name": "கள்ளக்குறிச்சி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567302012_382.jpg"
  },
  "kancheepuram": {
    "value": "TN_KC",
    "new_code": "KANCHEEPURAM",
    "label": "Kancheepuram",
    "rank": 551,
    "name_hi": "कांचीपुरम",
    "local_name": "காஞ்சிபுரம்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752578340177_146.webp"
  },
  "kanniyakumari": {
    "value": "TN_KK",
    "new_code": "KANNIYAKUMARI",
    "label": "Kanniyakumari",
    "rank": 552,
    "name_hi": "कन्याकूमारी",
    "local_name": "கன்னியாகுமரி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567261022_323.jpg"
  },
  "karur": {
    "value": "TN_KA",
    "new_code": "KARUR",
    "label": "Karur",
    "rank": 553,
    "name_hi": "करूर",
    "local_name": "கருர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567296149_355.jpg"
  },
  "krishnagiri": {
    "value": "TN_KR",
    "new_code": "KRISHNAGIRI",
    "label": "Krishnagiri",
    "rank": 554,
    "name_hi": "कृष्णागिरी",
    "local_name": "கிருஷ்ணகிரி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578358030_984.jpg"
  },
  "madurai": {
    "value": "TN_MA",
    "new_code": "MADURAI",
    "label": "Madurai",
    "rank": 555,
    "name_hi": "मदुरै",
    "local_name": "மதுரை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567250500_238.jpg"
  },
  "nagapattinam": {
    "value": "TN_NG",
    "new_code": "NAGAPATTINAM",
    "label": "Nagapattinam",
    "rank": 556,
    "name_hi": "नागपट्टिनम",
    "local_name": "நாகப்பட்டினம்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567541742_329.jpg"
  },
  "the-nilgiris": {
    "value": "TN_NI",
    "new_code": "THE_NILGIRIS",
    "label": "The Nilgiris",
    "rank": 557,
    "name_hi": "नीलगिरी",
    "local_name": "நீலகிரி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567340530_325.webp"
  },
  "namakkal": {
    "value": "TN_NM",
    "new_code": "NAMAKKAL",
    "label": "Namakkal",
    "rank": 558,
    "name_hi": "नमक्कल",
    "local_name": "நாமக்கல்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567540951_317.jpg"
  },
  "perambalur": {
    "value": "TN_PE",
    "new_code": "PERAMBALUR",
    "label": "Perambalur",
    "rank": 559,
    "name_hi": "पेरम्बलुर",
    "local_name": "பெரம்பலூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567300147_427.jpg"
  },
  "pudukkottai": {
    "value": "TN_PU",
    "new_code": "PUDUKKOTTAI",
    "label": "Pudukkottai",
    "rank": 560,
    "name_hi": "पुदुक्कोट्टई",
    "local_name": "புதுக்கோட்டை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578477226_658.jpg"
  },
  "ramanathapuram": {
    "value": "TN_RA",
    "new_code": "RAMANATHAPURAM",
    "label": "Ramanathapuram",
    "rank": 561,
    "name_hi": "रामनाथपुरम",
    "local_name": "இராமநாதபுரம்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567336388_462.jpg"
  },
  "salem": {
    "value": "TN_SA",
    "new_code": "SALEM",
    "label": "Salem",
    "rank": 562,
    "name_hi": "सलेम",
    "local_name": "சேலம்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567502558_663.webp"
  },
  "sivaganga": {
    "value": "TN_SI",
    "new_code": "SIVAGANGA",
    "label": "Sivaganga",
    "rank": 563,
    "name_hi": "शिवगंगा",
    "local_name": "சிவகங்கை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578540110_421.jpg"
  },
  "tiruppur": {
    "value": "TN_TP",
    "new_code": "TIRUPPUR",
    "label": "Tiruppur",
    "rank": 564,
    "name_hi": "तिरुपुर",
    "local_name": "திருப்பூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567263858_552.jpg"
  },
  "tiruchirappalli": {
    "value": "TN_TC",
    "new_code": "TIRUCHIRAPPALLI",
    "label": "Tiruchirappalli",
    "rank": 565,
    "name_hi": "तिरुचिरापल्ली",
    "local_name": "திருச்சி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567253569_53.webp"
  },
  "theni": {
    "value": "TN_TH",
    "new_code": "THENI",
    "label": "Theni",
    "rank": 566,
    "name_hi": "तब मैं",
    "local_name": "தேனி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578390721_223.jpg"
  },
  "tirunelveli": {
    "value": "TN_TI",
    "new_code": "TIRUNELVELI",
    "label": "Tirunelveli",
    "rank": 567,
    "name_hi": "तिरुनेलवेली",
    "local_name": "திருநெல்வேலி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567438762_766.jpg"
  },
  "thanjavur": {
    "value": "TN_TJ",
    "new_code": "THANJAVUR",
    "label": "Thanjavur",
    "rank": 568,
    "name_hi": "तंजावुर",
    "local_name": "தஞ்சாவூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578523518_621.jpg"
  },
  "thoothukkudi": {
    "value": "TN_TK",
    "new_code": "THOOTHUKKUDI",
    "label": "Thoothukkudi",
    "rank": 569,
    "name_hi": "थुतुकुकुडी",
    "local_name": "தூத்துக்குடி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578502799_32.jpg"
  },
  "thiruvallur": {
    "value": "TN_TL",
    "new_code": "THIRUVALLUR",
    "label": "Thiruvallur",
    "rank": 570,
    "name_hi": "तिरुवल्लुर",
    "local_name": "திருவள்ளூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567254649_227.webp"
  },
  "thiruvarur": {
    "value": "TN_TR",
    "new_code": "THIRUVARUR",
    "label": "Thiruvarur",
    "rank": 571,
    "name_hi": "तिरुवरुर",
    "local_name": "திருவாருர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578426909_488.jpg"
  },
  "tiruvannamalai": {
    "value": "TN_TV",
    "new_code": "TIRUVANNAMALAI",
    "label": "Tiruvannamalai",
    "rank": 572,
    "name_hi": "तिरुवन्नामलाई",
    "local_name": "திருவண்ணாமலை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567510155_874.jpg"
  },
  "vellore": {
    "value": "TN_VE",
    "new_code": "VELLORE",
    "label": "Vellore",
    "rank": 573,
    "name_hi": "वेल्लोर",
    "local_name": "வேலூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578443611_450.jpg"
  },
  "viluppuram": {
    "value": "TN_VL",
    "new_code": "VILUPPURAM",
    "label": "Viluppuram",
    "rank": 574,
    "name_hi": "विलुप्पुरम",
    "local_name": "விழுப்புரம்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567505427_619.jpg"
  },
  "virudhunagar": {
    "value": "TN_VR",
    "new_code": "VIRUDHUNAGAR",
    "label": "Virudhunagar",
    "rank": 575,
    "name_hi": "विरुधुनगर",
    "local_name": "விருதுநகர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567499949_282.jpg"
  },
  "adilabad": {
    "value": "TS_AD",
    "new_code": "ADILABAD",
    "label": "Adilabad",
    "rank": 576,
    "name_hi": "आदिलाबाद",
    "local_name": "ఆదిలాబాద్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567711217_656.jpg"
  },
  "komaram-bheem-asifabad": {
    "value": "TS_KBA",
    "new_code": "KOMARAM_BHEEM_ASIFABAD",
    "label": "Komaram Bheem Asifabad",
    "rank": 577,
    "name_hi": "यदाद्री भुवनगिरि",
    "local_name": "కుమురం భీమ్ ఆసిఫాబాద్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578717950_845.jpg"
  },
  "bhadrari-kothagudem": {
    "value": "TS_BK",
    "new_code": "BHADRARI_KOTHAGUDEM",
    "label": "Bhadrari Kothagudem",
    "rank": 578,
    "name_hi": "",
    "local_name": "భద్రాద్రి కొత్తగూడెం ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752578651089_109.webp"
  },
  "hyderabad": {
    "value": "TS_HY",
    "new_code": "HYDERABAD",
    "label": "Hyderabad",
    "rank": 579,
    "name_hi": "हैदराबाद",
    "local_name": "హైదరాబాద్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567861507_71.jpg"
  },
  "jagtial": {
    "value": "TS_JG",
    "new_code": "JAGTIAL",
    "label": "Jagtial",
    "rank": 580,
    "name_hi": "",
    "local_name": "జగిత్యాల",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567709757_582.jpg"
  },
  "jangaon": {
    "value": "TS_JA",
    "new_code": "JANGAON",
    "label": "Jangaon",
    "rank": 581,
    "name_hi": "",
    "local_name": "జనగామ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567901247_49.jpg"
  },
  "jaya-shankar-bhalupally": {
    "value": "TS_JB",
    "new_code": "JAYA_SHANKAR_BHALUPALLY",
    "label": "Jaya Shankar Bhalupally",
    "rank": 582,
    "name_hi": "",
    "local_name": "జయశంకర్ భూపాలపల్లి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567865477_15.jpg"
  },
  "jogulamba": {
    "value": "TS_JLG",
    "new_code": "JOGULAMBA",
    "label": "Jogulamba",
    "rank": 583,
    "name_hi": "",
    "local_name": "జోగులాంబ గద్వాల్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567713925_901.jpg"
  },
  "kamareddy": {
    "value": "TS_KR",
    "new_code": "KAMAREDDY",
    "label": "Kamareddy",
    "rank": 584,
    "name_hi": "",
    "local_name": "కామారెడ్డి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567867495_3.jpg"
  },
  "karimnagar": {
    "value": "TS_KA",
    "new_code": "KARIMNAGAR",
    "label": "Karimnagar",
    "rank": 585,
    "name_hi": "करीमनगर",
    "local_name": "కరీంనగర్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567870398_468.jpg"
  },
  "khammam": {
    "value": "TS_KH",
    "new_code": "KHAMMAM",
    "label": "Khammam",
    "rank": 586,
    "name_hi": "खम्मम",
    "local_name": "ఖమ్మం ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567825738_732.jpg"
  },
  "mahabubabad": {
    "value": "TS_MB",
    "new_code": "MAHABUBABAD",
    "label": "Mahabubabad",
    "rank": 587,
    "name_hi": "",
    "local_name": "మహబూబాబాద్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752578670433_874.webp"
  },
  "mahbubnagar": {
    "value": "TS_MA",
    "new_code": "MAHBUBNAGAR",
    "label": "Mahbubnagar",
    "rank": 588,
    "name_hi": "महबूबनगर",
    "local_name": "మహబూబ్ నగర్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567715289_798.jpg"
  },
  "mancherial": {
    "value": "TS_ML",
    "new_code": "MANCHERIAL",
    "label": "Mancherial",
    "rank": 589,
    "name_hi": "",
    "local_name": "మంచిర్యాల",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567750534_811.jpg"
  },
  "medak": {
    "value": "TS_ME",
    "new_code": "MEDAK",
    "label": "Medak",
    "rank": 590,
    "name_hi": "मेडक",
    "local_name": "మెదక్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567821929_631.jpg"
  },
  "medchal-malkajgiri": {
    "value": "TS_MH",
    "new_code": "MEDCHAL_MALKAJGIRI",
    "label": "Medchal Malkajgiri",
    "rank": 591,
    "name_hi": "",
    "local_name": "మేడ్చల్-మల్కాజ్ గిరి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567713160_373.jpg"
  },
  "nalgonda": {
    "value": "TS_NA",
    "new_code": "NALGONDA",
    "label": "Nalgonda",
    "rank": 592,
    "name_hi": "नलगोंडा",
    "local_name": "నల్గొండ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578755256_458.jpg"
  },
  "nagarkurnool": {
    "value": "TS_NK",
    "new_code": "NAGARKURNOOL",
    "label": "Nagarkurnool",
    "rank": 593,
    "name_hi": "",
    "local_name": "నాగర్ కర్నూల్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567707193_379.jpg"
  },
  "nirmal": {
    "value": "TS_NR",
    "new_code": "NIRMAL",
    "label": "Nirmal",
    "rank": 594,
    "name_hi": "",
    "local_name": "నిర్మల్ ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567934427_132.jpg"
  },
  "nizamabad": {
    "value": "TS_NI",
    "new_code": "NIZAMABAD",
    "label": "Nizamabad",
    "rank": 595,
    "name_hi": "निजामाबाद",
    "local_name": "నిజామాబాద్",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567704445_822.jpg"
  },
  "peddapalle": {
    "value": "TS_PD",
    "new_code": "PEDDAPALLE",
    "label": "Peddapalle",
    "rank": 596,
    "name_hi": "",
    "local_name": "పెద్దపల్లి",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567860472_991.webp"
  },
  "rajanna-sircilla": {
    "value": "TS_RS",
    "new_code": "RAJANNA_SIRCILLA",
    "label": "Rajanna Sircilla",
    "rank": 597,
    "name_hi": "",
    "local_name": "రాజన్న సిరిసిల్ల",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567816372_311.jpg"
  },
  "rangareddy": {
    "value": "TS_RA",
    "new_code": "RANGAREDDY",
    "label": "Rangareddy",
    "rank": 598,
    "name_hi": "रंगा रेड्डी",
    "local_name": "రంగారెడ్డి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567864383_37.webp"
  },
  "sangareddy": {
    "value": "TS_SR",
    "new_code": "SANGAREDDY",
    "label": "Sangareddy",
    "rank": 599,
    "name_hi": "",
    "local_name": "సంగారెడ్డి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567818479_114.jpg"
  },
  "siddipet": {
    "value": "TS_SD",
    "new_code": "SIDDIPET",
    "label": "Siddipet",
    "rank": 600,
    "name_hi": "",
    "local_name": "సిద్దిపేట ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567822940_136.jpg"
  },
  "suryapet": {
    "value": "TS_SP",
    "new_code": "SURYAPET",
    "label": "Suryapet",
    "rank": 601,
    "name_hi": "",
    "local_name": "సూర్యాపేట ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578692032_251.jpg"
  },
  "vikarabad": {
    "value": "TS_VK",
    "new_code": "VIKARABAD",
    "label": "Vikarabad",
    "rank": 602,
    "name_hi": "",
    "local_name": "వికారాబాద్",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578737531_614.jpg"
  },
  "wanaparthy": {
    "value": "TS_WP",
    "new_code": "WANAPARTHY",
    "label": "Wanaparthy",
    "rank": 603,
    "name_hi": "",
    "local_name": "వనపర్తి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567933757_704.jpg"
  },
  "warangal-urban": {
    "value": "TS_WL",
    "new_code": "WARANGAL_URBAN",
    "label": "Warangal Urban",
    "rank": 604,
    "name_hi": "वारंगल (शहरी)",
    "local_name": "వరంగల్ అర్బన్",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567859564_108.jpg"
  },
  "warangal-rural": {
    "value": "TS_WA",
    "new_code": "WARANGAL_RURAL",
    "label": "Warangal Rural",
    "rank": 605,
    "name_hi": "",
    "local_name": "వరంగల్ రూరల్",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567747867_192.jpg"
  },
  "yadadri": {
    "value": "TS_YB",
    "new_code": "YADADRI",
    "label": "Yadadri",
    "rank": 606,
    "name_hi": "",
    "local_name": "యాదాద్రి భువనగిరి ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567828823_983.jpg"
  },
  "dhalai": {
    "value": "TR_DH",
    "new_code": "DHALAI",
    "label": "Dhalai",
    "rank": 607,
    "name_hi": "धलाई",
    "local_name": "ঢালাই ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567702680_262.jpg"
  },
  "gomati": {
    "value": "TR_GM",
    "new_code": "GOMATI",
    "label": "Gomati",
    "rank": 608,
    "name_hi": "गोमती",
    "local_name": "গোমতী ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567665534_328.jpg"
  },
  "khowai": {
    "value": "TR_KH",
    "new_code": "KHOWAI",
    "label": "Khowai",
    "rank": 609,
    "name_hi": "खोवाई",
    "local_name": "খোয়াই ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567700721_783.jpg"
  },
  "north-tripura": {
    "value": "TR_NT",
    "new_code": "NORTH_TRIPURA",
    "label": "North Tripura",
    "rank": 610,
    "name_hi": "उत्तर त्रिपुरा",
    "local_name": "উত্তর ত্রিপুরা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567667766_34.webp"
  },
  "sepahijala": {
    "value": "TR_SP",
    "new_code": "SEPAHIJALA",
    "label": "Sepahijala",
    "rank": 611,
    "name_hi": "सेपाहिजाला",
    "local_name": "সিপাহিজালা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578570556_518.jpg"
  },
  "south-tripura": {
    "value": "TR_ST",
    "new_code": "SOUTH_TRIPURA",
    "label": "South Tripura",
    "rank": 612,
    "name_hi": "दक्षिण त्रिपुरा",
    "local_name": "দক্ষিণ ত্রিপুরা ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567662716_637.jpg"
  },
  "unokoti": {
    "value": "TR_UK",
    "new_code": "UNOKOTI",
    "label": "Unokoti",
    "rank": 613,
    "name_hi": "उकोकोट",
    "local_name": "ঊনকোটি ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567664610_299.jpg"
  },
  "west-tripura": {
    "value": "TR_WT",
    "new_code": "WEST_TRIPURA",
    "label": "West Tripura",
    "rank": 614,
    "name_hi": "पश्चिम त्रिपुरा",
    "local_name": "পশ্চিম ত্রিপুরা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567701774_569.jpg"
  },
  "agra": {
    "value": "UP_AG",
    "new_code": "AGRA",
    "label": "Agra",
    "rank": 615,
    "name_hi": "आगरा",
    "local_name": "आगरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573683614_966.jpg"
  },
  "aligarh": {
    "value": "UP_AL",
    "new_code": "ALIGARH",
    "label": "Aligarh",
    "rank": 616,
    "name_hi": "अलीगढ़",
    "local_name": "अलीगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573650778_365.jpg"
  },
  "allahabad": {
    "value": "UP_AH",
    "new_code": "ALLAHABAD",
    "label": "Allahabad",
    "rank": 617,
    "name_hi": "इलाहाबाद",
    "local_name": "इलाहाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574014913_680.jpg"
  },
  "ambedkar-nagar": {
    "value": "UP_AN",
    "new_code": "AMBEDKAR_NAGAR",
    "label": "Ambedkar Nagar",
    "rank": 618,
    "name_hi": "अंबेडकरनगर",
    "local_name": "अम्बेडकर नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573840877_649.jpg"
  },
  "amethi": {
    "value": "UP_CS",
    "new_code": "AMETHI",
    "label": "Amethi",
    "rank": 619,
    "name_hi": "अमेठी",
    "local_name": "अमेठी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573746270_951.jpg"
  },
  "amroha": {
    "value": "UP_JP",
    "new_code": "AMROHA",
    "label": "Amroha",
    "rank": 620,
    "name_hi": "अमरोहा",
    "local_name": "अमरोहा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573698735_229.jpg"
  },
  "auraiya": {
    "value": "UP_AU",
    "new_code": "AURAIYA",
    "label": "Auraiya",
    "rank": 621,
    "name_hi": "औरैया",
    "local_name": "औरैया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573939477_725.jpg"
  },
  "azamgarh": {
    "value": "UP_AZ",
    "new_code": "AZAMGARH",
    "label": "Azamgarh",
    "rank": 622,
    "name_hi": "आजमगढ़",
    "local_name": "आजमगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573748278_495.jpg"
  },
  "bagpat": {
    "value": "UP_BG",
    "new_code": "BAGPAT",
    "label": "Bagpat",
    "rank": 623,
    "name_hi": "बागपत",
    "local_name": "बागपत",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578962325_659.jpg"
  },
  "bahraich": {
    "value": "UP_BA",
    "new_code": "BAHRAICH",
    "label": "Bahraich",
    "rank": 624,
    "name_hi": "भदोही",
    "local_name": "बहराइच",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578946703_843.jpg"
  },
  "ballia": {
    "value": "UP_BL",
    "new_code": "BALLIA",
    "label": "Ballia",
    "rank": 625,
    "name_hi": "बलिया",
    "local_name": "बलिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573650105_195.webp"
  },
  "banda": {
    "value": "UP_BN",
    "new_code": "BANDA",
    "label": "Banda",
    "rank": 627,
    "name_hi": "बांदा",
    "local_name": "बांदा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752579044020_218.jpg"
  },
  "barabanki": {
    "value": "UP_BB",
    "new_code": "BARABANKI",
    "label": "Barabanki",
    "rank": 628,
    "name_hi": "बाराबंकी",
    "local_name": "बाराबंकी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573943602_893.jpg"
  },
  "bareilly": {
    "value": "UP_BR",
    "new_code": "BAREILLY",
    "label": "Bareilly",
    "rank": 629,
    "name_hi": "बरेली",
    "local_name": "बरेली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573687578_268.jpg"
  },
  "basti": {
    "value": "UP_BS",
    "new_code": "BASTI",
    "label": "Basti",
    "rank": 630,
    "name_hi": "बस्ती",
    "local_name": "बस्ती",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574014153_899.jpg"
  },
  "bhadohi": {
    "value": "UP_BH",
    "new_code": "BHADOHI",
    "label": "Bhadohi",
    "rank": 631,
    "name_hi": "भदोही",
    "local_name": "भदोही",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573701157_133.jpg"
  },
  "bijnor": {
    "value": "UP_BI",
    "new_code": "BIJNOR",
    "label": "Bijnor",
    "rank": 632,
    "name_hi": "बिजनौर",
    "local_name": "बिजनौर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573810113_896.jpg"
  },
  "budaun": {
    "value": "UP_BD",
    "new_code": "BUDAUN",
    "label": "Budaun",
    "rank": 633,
    "name_hi": "बदायूँ",
    "local_name": "बदायूँ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573695031_105.jpg"
  },
  "bulandshahr": {
    "value": "UP_BU",
    "new_code": "BULANDSHAHR",
    "label": "Bulandshahr",
    "rank": 634,
    "name_hi": "बुलंदशहर",
    "local_name": "बुलंदशहर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573706947_996.jpg"
  },
  "chandauli": {
    "value": "UP_CD",
    "new_code": "CHANDAULI",
    "label": "Chandauli",
    "rank": 635,
    "name_hi": "चंदौली",
    "local_name": "चंदौली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573697882_151.jpg"
  },
  "chitrakoot": {
    "value": "UP_CT",
    "new_code": "CHITRAKOOT",
    "label": "Chitrakoot",
    "rank": 636,
    "name_hi": "चित्रकूट",
    "local_name": "चित्रकूट",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573940941_845.webp"
  },
  "deoria": {
    "value": "UP_DE",
    "new_code": "DEORIA",
    "label": "Deoria",
    "rank": 637,
    "name_hi": "देवरिया",
    "local_name": "देवरिया",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573684248_187.jpg"
  },
  "etah": {
    "value": "UP_ET",
    "new_code": "ETAH",
    "label": "Etah",
    "rank": 638,
    "name_hi": "एटा",
    "local_name": "एटा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752578920523_231.webp"
  },
  "etawah": {
    "value": "UP_EW",
    "new_code": "ETAWAH",
    "label": "Etawah",
    "rank": 639,
    "name_hi": "इटावा",
    "local_name": "इटावा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578989547_138.jpg"
  },
  "faizabad": {
    "value": "UP_FZ",
    "new_code": "FAIZABAD",
    "label": "Faizabad",
    "rank": 640,
    "name_hi": "फैजाबाद",
    "local_name": "फैजाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578962325_659.jpg"
  },
  "farrukhabad": {
    "value": "UP_FR",
    "new_code": "FARRUKHABAD",
    "label": "Farrukhabad",
    "rank": 641,
    "name_hi": "फर्रुखाबाद",
    "local_name": "फर्रुखाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573689133_352.jpg"
  },
  "fatehpur": {
    "value": "UP_FT",
    "new_code": "FATEHPUR",
    "label": "Fatehpur",
    "rank": 642,
    "name_hi": "फतेहपुर",
    "local_name": "फतेहपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573842166_995.jpg"
  },
  "firozabad": {
    "value": "UP_FI",
    "new_code": "FIROZABAD",
    "label": "Firozabad",
    "rank": 643,
    "name_hi": "फिरोजाबाद",
    "local_name": "फिरोजाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573649446_39.jpg"
  },
  "gautam-buddh-nagar": {
    "value": "UP_GB",
    "new_code": "GAUTAM_BUDDH_NAGAR",
    "label": "Gautam Buddh Nagar",
    "rank": 644,
    "name_hi": "गौतम बुद्ध नगर",
    "local_name": "गौतम बुद्ध नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578875427_866.jpg"
  },
  "ghaziabad": {
    "value": "UP_GZ",
    "new_code": "GHAZIABAD",
    "label": "Ghaziabad",
    "rank": 645,
    "name_hi": "गाज़ियाबाद",
    "local_name": "गाज़ियाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573681461_341.jpg"
  },
  "ghazipur": {
    "value": "UP_GP",
    "new_code": "GHAZIPUR",
    "label": "Ghazipur",
    "rank": 646,
    "name_hi": "गाजीपुर",
    "local_name": "गाजीपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752574008898_868.webp"
  },
  "gonda": {
    "value": "UP_GN",
    "new_code": "GONDA",
    "label": "Gonda",
    "rank": 647,
    "name_hi": "गोंडा",
    "local_name": "गोण्डा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573691363_747.jpg"
  },
  "gorakhpur": {
    "value": "UP_GR",
    "new_code": "GORAKHPUR",
    "label": "Gorakhpur",
    "rank": 648,
    "name_hi": "गोरखपुर",
    "local_name": "गोरखपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573705293_171.jpg"
  },
  "hapur": {
    "value": "UP_PN",
    "new_code": "HAPUR",
    "label": "Hapur",
    "rank": 650,
    "name_hi": "हापुड़",
    "local_name": "हापुड़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573907799_222.jpg"
  },
  "hardoi": {
    "value": "UP_HR",
    "new_code": "HARDOI",
    "label": "Hardoi",
    "rank": 651,
    "name_hi": "हरदोई",
    "local_name": "हरदोई",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573707577_382.webp"
  },
  "hathras": {
    "value": "UP_HT",
    "new_code": "HATHRAS",
    "label": "Hathras",
    "rank": 652,
    "name_hi": "हाथरस",
    "local_name": "हाथरस",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573975265_909.webp"
  },
  "jalaun": {
    "value": "UP_JL",
    "new_code": "JALAUN",
    "label": "Jalaun",
    "rank": 653,
    "name_hi": "जालौन",
    "local_name": "जालौन",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573944657_462.jpg"
  },
  "jaunpur": {
    "value": "UP_JU",
    "new_code": "JAUNPUR",
    "label": "Jaunpur",
    "rank": 654,
    "name_hi": "जौनपुर",
    "local_name": "जौनपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573701833_878.jpg"
  },
  "jhansi": {
    "value": "UP_JH",
    "new_code": "JHANSI",
    "label": "Jhansi",
    "rank": 655,
    "name_hi": "झांसी",
    "local_name": "झाँसी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573690615_627.jpg"
  },
  "kannauj": {
    "value": "UP_KJ",
    "new_code": "KANNAUJ",
    "label": "Kannauj",
    "rank": 656,
    "name_hi": "कन्नौज",
    "local_name": "कन्नौज",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573873061_640.jpg"
  },
  "kanpur-dehat": {
    "value": "UP_KD",
    "new_code": "KANPUR_DEHAT",
    "label": "Kanpur Dehat",
    "rank": 657,
    "name_hi": "कानपुर देहात",
    "local_name": "कानपुर देहात",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752579063411_432.jpg"
  },
  "kanpur-nagar": {
    "value": "UP_KN",
    "new_code": "KANPUR_NAGAR",
    "label": "Kanpur Nagar",
    "rank": 658,
    "name_hi": "कानपुर नगर",
    "local_name": "कानपुर नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573684855_639.webp"
  },
  "kasganj": {
    "value": "UP_KR",
    "new_code": "KASGANJ",
    "label": "Kasganj",
    "rank": 659,
    "name_hi": "कासगंज",
    "local_name": "कासगंज",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573682309_716.jpg"
  },
  "kaushambi": {
    "value": "UP_KS",
    "new_code": "KAUSHAMBI",
    "label": "Kaushambi",
    "rank": 660,
    "name_hi": "कौशाम्बी",
    "local_name": "कौशाम्बी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573697130_712.jpg"
  },
  "kushinagar": {
    "value": "UP_KU",
    "new_code": "KUSHINAGAR",
    "label": "Kushinagar",
    "rank": 661,
    "name_hi": "कुशीनगर",
    "local_name": "कुशीनगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573977174_487.jpg"
  },
  "lakhimpur-kheri": {
    "value": "UP_LK",
    "new_code": "LAKHIMPUR_KHERI",
    "label": "Lakhimpur Kheri",
    "rank": 662,
    "name_hi": "लखीमपुर खीरी",
    "local_name": "लखीमपुर खीरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573647301_372.jpg"
  },
  "lalitpur": {
    "value": "UP_LA",
    "new_code": "LALITPUR",
    "label": "Lalitpur",
    "rank": 663,
    "name_hi": "ललितपुर",
    "local_name": "ललितपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573710382_684.jpg"
  },
  "lucknow": {
    "value": "UP_LU",
    "new_code": "LUCKNOW",
    "label": "Lucknow",
    "rank": 664,
    "name_hi": "लखनऊ",
    "local_name": "लखनऊ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574011915_625.jpg"
  },
  "maharajganj": {
    "value": "UP_MG",
    "new_code": "MAHARAJGANJ",
    "label": "Maharajganj",
    "rank": 665,
    "name_hi": "महाराजगंज",
    "local_name": "महाराजगंज",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573648782_571.webp"
  },
  "mahoba": {
    "value": "UP_MH",
    "new_code": "MAHOBA",
    "label": "Mahoba",
    "rank": 666,
    "name_hi": "महोबा",
    "local_name": "महोबा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573699367_169.jpg"
  },
  "mainpuri": {
    "value": "UP_MP",
    "new_code": "MAINPURI",
    "label": "Mainpuri",
    "rank": 667,
    "name_hi": "मैनपुरी",
    "local_name": "मैनपुरी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573808944_396.jpg"
  },
  "mathura": {
    "value": "UP_MT",
    "new_code": "MATHURA",
    "label": "Mathura",
    "rank": 668,
    "name_hi": "मथुरा",
    "local_name": "मथुरा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752579024465_282.jpg"
  },
  "mau": {
    "value": "UP_MB",
    "new_code": "MAU",
    "label": "Mau",
    "rank": 669,
    "name_hi": "मऊ",
    "local_name": "मऊ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573646018_896.jpg"
  },
  "meerut": {
    "value": "UP_ME",
    "new_code": "MEERUT",
    "label": "Meerut",
    "rank": 670,
    "name_hi": "मेरठ",
    "local_name": "मेरठ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752579007140_990.jpg"
  },
  "mirzapur": {
    "value": "UP_MI",
    "new_code": "MIRZAPUR",
    "label": "Mirzapur",
    "rank": 671,
    "name_hi": "मिर्जापुर",
    "local_name": "मिर्जापुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573706227_89.jpg"
  },
  "moradabad": {
    "value": "UP_MO",
    "new_code": "MORADABAD",
    "label": "Moradabad",
    "rank": 672,
    "name_hi": "मुरादाबाद",
    "local_name": "मुरादाबाद",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573908668_367.jpg"
  },
  "muzaffarnagar": {
    "value": "UP_MU",
    "new_code": "MUZAFFARNAGAR",
    "label": "Muzaffarnagar",
    "rank": 673,
    "name_hi": "मुजफ्फरनगर",
    "local_name": "मुजफ्फरनगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573940150_471.jpg"
  },
  "pilibhit": {
    "value": "UP_PI",
    "new_code": "PILIBHIT",
    "label": "Pilibhit",
    "rank": 674,
    "name_hi": "पीलीभीत",
    "local_name": "पीलीभीत",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573702498_179.jpg"
  },
  "raebareli": {
    "value": "UP_RB",
    "new_code": "RAEBARELI",
    "label": "Raebareli",
    "rank": 676,
    "name_hi": "रायबरेली",
    "local_name": "रायबरेली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573689891_234.jpg"
  },
  "rampur": {
    "value": "UP_RA",
    "new_code": "RAMPUR",
    "label": "Rampur",
    "rank": 677,
    "name_hi": "रामपुर",
    "local_name": "रामपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573646664_476.jpg"
  },
  "saharanpur": {
    "value": "UP_SA",
    "new_code": "SAHARANPUR",
    "label": "Saharanpur",
    "rank": 678,
    "name_hi": "सहारनपुर",
    "local_name": "सहारनपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573693336_670.webp"
  },
  "sambhal": {
    "value": "UP_SM",
    "new_code": "SAMBHAL",
    "label": "Sambhal",
    "rank": 679,
    "name_hi": "संभल",
    "local_name": "संभल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573712862_441.jpg"
  },
  "sant-kabir-nagar": {
    "value": "UP_SK",
    "new_code": "SANT_KABIR_NAGAR",
    "label": "Sant Kabir Nagar",
    "rank": 680,
    "name_hi": "संत कबीर नगर",
    "local_name": "संत कबीर नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573703094_275.webp"
  },
  "shahjahanpur": {
    "value": "UP_SJ",
    "new_code": "SHAHJAHANPUR",
    "label": "Shahjahanpur",
    "rank": 681,
    "name_hi": "शाहजहांपुर",
    "local_name": "शाहजहाँपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573691979_363.jpg"
  },
  "shamli": {
    "value": "UP_SH",
    "new_code": "SHAMLI",
    "label": "Shamli",
    "rank": 682,
    "name_hi": "शामली",
    "local_name": "शामली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752573692636_8.webp"
  },
  "shravasti": {
    "value": "UP_SV",
    "new_code": "SHRAVASTI",
    "label": "Shravasti",
    "rank": 683,
    "name_hi": "श्रावस्ती",
    "local_name": "श्रावस्ती",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573695847_166.jpg"
  },
  "siddharthnagar": {
    "value": "UP_SN",
    "new_code": "SIDDHARTHNAGAR",
    "label": "Siddharthnagar",
    "rank": 684,
    "name_hi": "सिद्धार्थनगर",
    "local_name": "सिद्धार्थनगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573696473_293.jpg"
  },
  "sitapur": {
    "value": "UP_SI",
    "new_code": "SITAPUR",
    "label": "Sitapur",
    "rank": 685,
    "name_hi": "सीतापुर",
    "local_name": "सीतापुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573809486_284.jpg"
  },
  "sonbhadra": {
    "value": "UP_SO",
    "new_code": "SONBHADRA",
    "label": "Sonbhadra",
    "rank": 686,
    "name_hi": "सोनभद्र",
    "local_name": "सोनभद्र",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573709762_18.jpg"
  },
  "sultanpur": {
    "value": "UP_SU",
    "new_code": "SULTANPUR",
    "label": "Sultanpur",
    "rank": 687,
    "name_hi": "सुल्तानपुर",
    "local_name": "सुल्तानपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573743474_798.jpg"
  },
  "unnao": {
    "value": "UP_UN",
    "new_code": "UNNAO",
    "label": "Unnao",
    "rank": 688,
    "name_hi": "उन्नाव",
    "local_name": "उन्नाव",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752579085883_433.webp"
  },
  "varanasi": {
    "value": "UP_VA",
    "new_code": "VARANASI",
    "label": "Varanasi",
    "rank": 689,
    "name_hi": "वाराणसी",
    "local_name": "वाराणसी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573682974_341.jpg"
  },
  "almora": {
    "value": "UK_AL",
    "new_code": "ALMORA",
    "label": "Almora",
    "rank": 690,
    "name_hi": "अल्मोड़ा",
    "local_name": "अल्मोड़ा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567939635_506.jpg"
  },
  "bageshwar": {
    "value": "UK_BA",
    "new_code": "BAGESHWAR",
    "label": "Bageshwar",
    "rank": 691,
    "name_hi": "बागेश्वर",
    "local_name": "बागेश्वर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578773715_272.jpg"
  },
  "chamoli": {
    "value": "UK_CL",
    "new_code": "CHAMOLI",
    "label": "Chamoli",
    "rank": 692,
    "name_hi": "चमोली",
    "local_name": "चमोली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573642870_274.jpg"
  },
  "champawat": {
    "value": "UK_CP",
    "new_code": "CHAMPAWAT",
    "label": "Champawat",
    "rank": 693,
    "name_hi": "चम्पावत",
    "local_name": "चम्पावत",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567941347_80.jpg"
  },
  "dehradun": {
    "value": "UK_DD",
    "new_code": "DEHRADUN",
    "label": "Dehradun",
    "rank": 694,
    "name_hi": "देहरादून",
    "local_name": "देहरादून",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567943317_504.jpg"
  },
  "haridwar": {
    "value": "UK_HA",
    "new_code": "HARIDWAR",
    "label": "Haridwar",
    "rank": 695,
    "name_hi": "हरिद्वार",
    "local_name": "हरिद्वार",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573641070_31.jpg"
  },
  "nainital": {
    "value": "UK_NA",
    "new_code": "NAINITAL",
    "label": "Nainital",
    "rank": 696,
    "name_hi": "नैनीताल",
    "local_name": "नैनीताल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567937238_969.jpg"
  },
  "garhwal": {
    "value": "UK_PG",
    "new_code": "GARHWAL",
    "label": "Garhwal",
    "rank": 697,
    "name_hi": "पौड़ी गढ़वाल",
    "local_name": "पौड़ी गढ़वाल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573610259_353.jpg"
  },
  "pithoragarh": {
    "value": "UK_PI",
    "new_code": "PITHORAGARH",
    "label": "Pithoragarh",
    "rank": 698,
    "name_hi": "पिथोरागढ़",
    "local_name": "पिथोरागढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567942332_260.jpg"
  },
  "rudraprayag": {
    "value": "UK_RP",
    "new_code": "RUDRAPRAYAG",
    "label": "Rudraprayag",
    "rank": 699,
    "name_hi": "रुद्रप्रयाग",
    "local_name": "रुद्रप्रयाग",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573607386_524.jpg"
  },
  "tehri-garhwal": {
    "value": "UK_TG",
    "new_code": "TEHRI_GARHWAL",
    "label": "Tehri Garhwal",
    "rank": 700,
    "name_hi": "टिहरी गढ़वाल",
    "local_name": "टिहरी गढ़वाल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573609547_354.jpg"
  },
  "udham-singh-nagar": {
    "value": "UK_US",
    "new_code": "UDHAM_SINGH_NAGAR",
    "label": "Udham Singh Nagar",
    "rank": 701,
    "name_hi": "उधम सिंह नगर",
    "local_name": "उधम सिंह नगर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573606697_597.jpg"
  },
  "uttarkashi": {
    "value": "UK_UT",
    "new_code": "UTTARKASHI",
    "label": "Uttarkashi",
    "rank": 702,
    "name_hi": "उत्तरकाशी",
    "local_name": "उत्तरकाशी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752573645228_978.jpg"
  },
  "alipurduar": {
    "value": "WB_AD",
    "new_code": "ALIPURDUAR",
    "label": "Alipurduar",
    "rank": 703,
    "name_hi": "अलीपुरद्वार",
    "local_name": "আলিপুরদুয়ার",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574130241_418.jpg"
  },
  "bankura": {
    "value": "WB_BN",
    "new_code": "BANKURA",
    "label": "Bankura",
    "rank": 704,
    "name_hi": "बांकुड़ा",
    "local_name": "বাঁকুড়া",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574055788_70.jpg"
  },
  "paschim-bardhaman": {
    "value": "WB_PB",
    "new_code": "PASCHIM_BARDHAMAN",
    "label": "Paschim Bardhaman",
    "rank": 705,
    "name_hi": "पस्चिम बर्धमान",
    "local_name": "পশ্চিম বর্ধমান",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574050748_105.jpg"
  },
  "purba-bardhaman": {
    "value": "WB_BR",
    "new_code": "PURBA_BARDHAMAN",
    "label": "Purba Bardhaman",
    "rank": 706,
    "name_hi": "पुरबा बर्धमान",
    "local_name": "পূর্ব বর্ধমান",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574049329_717.jpg"
  },
  "birbhum": {
    "value": "WB_BI",
    "new_code": "BIRBHUM",
    "label": "Birbhum",
    "rank": 707,
    "name_hi": "बीरभूम",
    "local_name": "বীরভূম",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574127068_121.jpg"
  },
  "cooch-behar": {
    "value": "WB_KB",
    "new_code": "COOCH_BEHAR",
    "label": "Cooch Behar",
    "rank": 708,
    "name_hi": "कूच बिहार",
    "local_name": "কোচ বিহার",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574063794_804.jpg"
  },
  "dakshin-dinajpur": {
    "value": "WB_DD",
    "new_code": "DAKSHIN_DINAJPUR",
    "label": "Dakshin Dinajpur",
    "rank": 709,
    "name_hi": "दक्षिण दिनाजपुर",
    "local_name": "দক্ষিণ দিনাজপুর",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574057250_200.jpg"
  },
  "darjeeling": {
    "value": "WB_DA",
    "new_code": "DARJEELING",
    "label": "Darjeeling",
    "rank": 710,
    "name_hi": "दार्जिलिंग",
    "local_name": "দার্জিলিং",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574047669_835.jpg"
  },
  "hooghly": {
    "value": "WB_HG",
    "new_code": "HOOGHLY",
    "label": "Hooghly",
    "rank": 711,
    "name_hi": "हुगली",
    "local_name": "হুগলী",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574050045_768.jpg"
  },
  "howrah": {
    "value": "WB_HR",
    "new_code": "HOWRAH",
    "label": "Howrah",
    "rank": 712,
    "name_hi": "हावड़ा",
    "local_name": "হাওড়া",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574061106_851.jpg"
  },
  "jalpaiguri": {
    "value": "WB_JA",
    "new_code": "JALPAIGURI",
    "label": "Jalpaiguri",
    "rank": 713,
    "name_hi": "जलपाईगुड़ी",
    "local_name": "জলপাইগুড়ি",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574064364_42.jpg"
  },
  "jhargam": {
    "value": "WB_JH",
    "new_code": "JHARGAM",
    "label": "Jhargam",
    "rank": 714,
    "name_hi": "झारग्राम",
    "local_name": "ঝাড়গ্রাম",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574060200_569.jpg"
  },
  "kalimpong": {
    "value": "WB_KA",
    "new_code": "KALIMPONG",
    "label": "Kalimpong",
    "rank": 715,
    "name_hi": "कलिम्पोंग",
    "local_name": "কালিম্পং",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574048626_733.jpg"
  },
  "kolkata": {
    "value": "WB_KO",
    "new_code": "KOLKATA",
    "label": "Kolkata",
    "rank": 716,
    "name_hi": "कोलकाता",
    "local_name": "কলকাতা ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574129681_815.jpg"
  },
  "maldah": {
    "value": "WB_MA",
    "new_code": "MALDAH",
    "label": "Maldah",
    "rank": 717,
    "name_hi": "मालदा",
    "local_name": "মালদা ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574056542_76.jpg"
  },
  "murshidabad": {
    "value": "WB_MSD",
    "new_code": "MURSHIDABAD",
    "label": "Murshidabad",
    "rank": 718,
    "name_hi": "मुर्शिदाबाद",
    "local_name": "মুরশিদাবাদ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574128382_923.jpg"
  },
  "nadia": {
    "value": "WB_NA",
    "new_code": "NADIA",
    "label": "Nadia",
    "rank": 719,
    "name_hi": "नादिया",
    "local_name": "নদীয়া ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574128974_937.jpg"
  },
  "north-twenty-four-parganas": {
    "value": "WB_PN",
    "new_code": "NORTH_TWENTY_FOUR_PARGANAS",
    "label": "North Twenty Four Parganas",
    "rank": 720,
    "name_hi": "उत्तर 24 परगना",
    "local_name": "উত্তর ২৪ পরগনা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752579176893_329.jpg"
  },
  "paschim-medinipur": {
    "value": "WB_PM",
    "new_code": "PASCHIM_MEDINIPUR",
    "label": "Paschim Medinipur",
    "rank": 721,
    "name_hi": "पासीम मेदिनीपुर",
    "local_name": "পশ্চিম মেদিনীপুর",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574127696_356.jpg"
  },
  "purba-medinipur": {
    "value": "WB_PR",
    "new_code": "PURBA_MEDINIPUR",
    "label": "Purba Medinipur",
    "rank": 722,
    "name_hi": "पूर्बा मेदिनीपुर",
    "local_name": "পূর্ব মেদিনীপুর",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574132565_59.jpg"
  },
  "purulia": {
    "value": "WB_PU",
    "new_code": "PURULIA",
    "label": "Purulia",
    "rank": 723,
    "name_hi": "पुरुलिया",
    "local_name": "পুরুলিয়া",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752579123088_280.jpg"
  },
  "south-twenty-four-parganas": {
    "value": "WB_PS",
    "new_code": "SOUTH_TWENTY_FOUR_PARGANAS",
    "label": "South Twenty Four Parganas",
    "rank": 724,
    "name_hi": "दक्षिण 24 परगना",
    "local_name": "দক্ষিণ ২৪ পরগনা",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752579106694_554.webp"
  },
  "uttar-dinajpur": {
    "value": "WB_UD",
    "new_code": "UTTAR_DINAJPUR",
    "label": "Uttar Dinajpur",
    "rank": 725,
    "name_hi": "उत्तर दिनाजपुर",
    "local_name": "উত্তর দিনাজপুর",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752574054550_532.jpg"
  },
  "narayanpet": {
    "value": "TS_NP",
    "new_code": "NARAYANPET",
    "label": "Narayanpet",
    "rank": 726,
    "name_hi": "",
    "local_name": "నారాయణపేట ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752571787425_879.jpg"
  },
  "mulugu": {
    "value": "TS_MU",
    "new_code": "MULUGU",
    "label": "Mulugu",
    "rank": 727,
    "name_hi": "",
    "local_name": "ములుగు ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567863308_604.jpg"
  },
  "chengalpattu": {
    "value": "TN_CGL",
    "new_code": "CHENGALPATTU",
    "label": "Chengalpattu",
    "rank": 728,
    "name_hi": "चेंगलपट्टू",
    "local_name": "செங்கல்பட்டு",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752578374779_611.jpg"
  },
  "tirupathur": {
    "value": "TN_TPP",
    "new_code": "TIRUPATHUR",
    "label": "Tirupathur",
    "rank": 729,
    "name_hi": "तिरुपत्तुर",
    "local_name": "திருப்பத்தூர்",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567344092_218.jpg"
  },
  "ranipet": {
    "value": "TN_RNP",
    "new_code": "RANIPET",
    "label": "Ranipet",
    "rank": 730,
    "name_hi": "रानीपेट",
    "local_name": "இராணிப்பேட்டை",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567435914_764.jpg"
  },
  "tenkasi": {
    "value": "TN_TKS",
    "new_code": "TENKASI",
    "label": "Tenkasi",
    "rank": 731,
    "name_hi": "तेनकासी",
    "local_name": "தென்காசி",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567252185_921.jpg"
  },
  "vijayanagara": {
    "value": "KA_VI",
    "new_code": "VIJAYANAGARA",
    "label": "Vijayanagara",
    "rank": 732,
    "name_hi": "विजयनगर",
    "local_name": "ವಿಜಯನಗರ",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752577427926_524.jpg"
  },
  "gangtok": {
    "value": "SK_GNG",
    "new_code": "GANGTOK",
    "label": "Gangtok",
    "rank": 2627,
    "name_hi": "गंगटोक",
    "local_name": "गंगटोक"
  },
  "mangan": {
    "value": "SK_MAN",
    "new_code": "MANGAN",
    "label": "Mangan",
    "rank": 2628,
    "name_hi": "मंगन",
    "local_name": "मंगन"
  },
  "gyalshing": {
    "value": "SK_GYA",
    "new_code": "GYALSHING",
    "label": "Gyalshing",
    "rank": 2629,
    "name_hi": "गेजिंग",
    "local_name": "गेजिंग"
  },
  "namchi": {
    "value": "SK_NAM",
    "new_code": "NAMCHI",
    "label": "Namchi",
    "rank": 2630,
    "name_hi": "नामची",
    "local_name": "नामची"
  },
  "pakyong": {
    "value": "SK_PAK",
    "new_code": "PAKYONG",
    "label": "Pakyong",
    "rank": 2631,
    "name_hi": "पाकॉन्ग",
    "local_name": "पाकॉन्ग"
  },
  "soreng": {
    "value": "SK_SOR",
    "new_code": "SORENG",
    "label": "Soreng",
    "rank": 2632,
    "name_hi": "सोरेंग",
    "local_name": "सोरेंग"
  },
  "khairagarh-chhuikhadan-gandai": {
    "value": "CG_KCG",
    "new_code": "KHAIRAGARH_CHHUIKHADAN_GANDAI",
    "label": "Khairagarh Chhuikhadan Gandai",
    "rank": 2633,
    "name_hi": "खैरगढ़ छुइखडन गंडई",
    "local_name": "खैरगढ़ छुइखडन गंडई",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567129693_948.jpg"
  },
  "manendragarh-chirmiri-bharatpur": {
    "value": "CG_MCB",
    "new_code": "MANENDRAGARH_CHIRMIRI_BHARATPUR",
    "label": "Manendragarh Chirmiri Bharatpur",
    "rank": 2634,
    "name_hi": "मनेंद्रगढ़ चिरमिरी भरतपुर",
    "local_name": "मनेंद्रगढ़ चिरमिरी भरतपुर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576913678_833.jpg"
  },
  "mohla-manpur-ambagarh-chowki": {
    "value": "CG_MMAC",
    "new_code": "MOHLA_MANPUR_AMBAGARH_CHOWKI",
    "label": "Mohla Manpur Ambagarh Chowki",
    "rank": 2635,
    "name_hi": "मोहला मानपुर अंबागढ़ चौकी",
    "local_name": "मोहला मानपुर अंबागढ़ चौकी",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567125622_828.jpg"
  },
  "sarangarh-bilaigarh": {
    "value": "CG_SB",
    "new_code": "SARANGARH_BILAIGARH",
    "label": "Sarangarh Bilaigarh",
    "rank": 2636,
    "name_hi": "सारंगढ़ बिलाईगढ़",
    "local_name": "सारंगढ़ बिलाईगढ़",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567171194_590.jpg"
  },
  "sakti": {
    "value": "CG_SA",
    "new_code": "SAKTI",
    "label": "Sakti",
    "rank": 2637,
    "name_hi": "सक्ती",
    "local_name": "सक्ती",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567180651_951.jpg"
  },
  "tirupati": {
    "value": "AP_TRP",
    "new_code": "TIRUPATI",
    "label": "Tirupati",
    "rank": 2638,
    "name_hi": "तिरुपति",
    "local_name": "तिरुपति",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567082992_575.jpg"
  },
  "nandyal": {
    "value": "AP_NAN",
    "new_code": "NANDYAL",
    "label": "Nandyal",
    "rank": 2639,
    "name_hi": "नांदयाल",
    "local_name": "नांदयाल",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576102843_691.jpg"
  },
  "ntr": {
    "value": "AP_NTR",
    "new_code": "NTR",
    "label": "NTR",
    "rank": 2640,
    "name_hi": "एनटीआर",
    "local_name": "एनटीआर",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567284456_298.jpg"
  },
  "annamayya": {
    "value": "AP_ANN",
    "new_code": "ANNAMAYYA",
    "label": "Annamayya",
    "rank": 2641,
    "name_hi": "अन्नमय्या",
    "local_name": "अन्नमय्या",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576184345_728.jpg"
  },
  "anakapalli": {
    "value": "AP_ANA",
    "new_code": "ANAKAPALLI",
    "label": "Anakapalli",
    "rank": 2642,
    "name_hi": "अनकापल्ली",
    "local_name": "अनकापल्ली",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567090563_494.jpg"
  },
  "sri-sathyasai": {
    "value": "AP_SST",
    "new_code": "SRI_SATHYASAI",
    "label": "Sri Sathyasai",
    "rank": 2643,
    "name_hi": "श्री सत्यसई",
    "local_name": "श्री सत्यसई",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567154051_414.jpg"
  },
  "palnadu": {
    "value": "AP_PAL",
    "new_code": "PALNADU",
    "label": "Palnadu",
    "rank": 2644,
    "name_hi": "पालनाडु",
    "local_name": "पालनाडु",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567084266_249.jpg"
  },
  "eluru": {
    "value": "AP_ELU",
    "new_code": "ELURU",
    "label": "Eluru",
    "rank": 2645,
    "name_hi": "एलुरु",
    "local_name": "एलुरु",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576160444_237.jpg"
  },
  "konaseema": {
    "value": "AP_KON",
    "new_code": "KONASEEMA",
    "label": "Konaseema",
    "rank": 2646,
    "name_hi": "कोनासीमा",
    "local_name": "कोनासीमा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567315079_125.jpg"
  },
  "bapatla": {
    "value": "AP_BAP",
    "new_code": "BAPATLA",
    "label": "Bapatla",
    "rank": 2647,
    "name_hi": "बापतला",
    "local_name": "बापतला",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567188015_246.webp"
  },
  "kakinada": {
    "value": "AP_KAK",
    "new_code": "KAKINADA",
    "label": "Kakinada",
    "rank": 2648,
    "name_hi": "काकीनाडा",
    "local_name": "काकीनाडा",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752576026997_283.jpg"
  },
  "alluri-sitharama-raju": {
    "value": "AP_ASR",
    "new_code": "ALLURI_SITHARAMA_RAJU",
    "label": "Alluri Sitharama Raju",
    "rank": 2649,
    "name_hi": "अल्लुरी सितारमा राजू",
    "local_name": "अल्लुरी सितारमा राजू",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/jpg/m/2025/07_jul/15_tue/img_1752567087722_837.jpg"
  },
  "parvathipuram-manyam": {
    "value": "AP_PPM",
    "new_code": "PARVATHIPURAM_MANYAM",
    "label": "Parvathipuram Manyam",
    "rank": 2650,
    "name_hi": "पार्वतीपुरम मानम",
    "local_name": "पार्वतीपुरम मानम",
    "image_url": "https://static.inshorts.com/public/images/v1/variants/webp/m/2025/07_jul/15_tue/img_1752567155974_749.webp"
  }
}

export const ALL_DISTRICTS_FLAT = Object.entries(_ALL_DISTRICTS_FLAT).reduce((acc, [district_path, district]) => {
  acc[`news-in-${district_path}`] = district
  return acc;
}, {} as Record<string, Omit<LocationDistrict, 'state_code' | 'district_path'>>);

export const ALL_DISTRICTS = Object.entries(ALL_DISTRICTS_FLAT).reduce((acc, [district_path, district]) => {
  const [stateCode] = district.value.split('_');
  if (!acc[stateCode]) {
    acc[stateCode] = {};
  }
  acc[stateCode][district_path] = { ...district, state_code: stateCode, district_path };
  return acc;
}, {} as Record<string, Record<string, LocationDistrict>>);

export const DISTRICTS_CODE_TO_SLUG = Object.entries(ALL_DISTRICTS_FLAT).reduce((acc, [districtCode, district]) => {
  acc[district.value] = districtCode
  return acc
}, {} as Record<string, string>);

export const STATE_MAJOR_DISTRICTS: Record<string, string[]> = {
  BR: [
    "BR_PA", "BR_MZ", "BR_SR", "BR_DA", "BR_SU", "BR_PU", "BR_BG", "BR_MG", "BR_GA"
  ],
  UK: [
    "UK_TG", "UK_PI", "UK_NA"
  ],
  HR: [
    "HR_AM", "HR_FR", "HR_GU", "HR_HI", "HR_RO", "HR_KR"
  ],
  RJ: [
    "RJ_AJ", "RJ_BP", "RJ_BI", "RJ_JP", "RJ_JO", "RJ_KO", "RJ_UD"
  ],
  CG: [
    "CG_RP", "CG_BI", "CG_DU", "CG_BA", "CG_SG"
  ],
  UP: [
    "UP_AH", "UP_AZ", "UP_CT", "UP_GN", "UP_JH", "UP_SA", "UP_AG", "UP_AL", "UP_BR", "UP_KN", "UP_GR", "UP_ME", "UP_MO", "UP_BS", "UP_LU", "UP_MI", "UP_VA", "UP_FZ"
  ],
  MP: [
    "MP_BP", "MP_GW", "MP_IN", "MP_JA", "MP_CT", "MP_UJ"
  ],
  JH: [
    "JH_RA", "JH_BO", "JH_GU"
  ],
  HP: [
    "HP_KA", "HP_MA", "HP_SH"
  ],
  DL: [
    "DL_CD", "DL_WD", "DL_NO", "DL_ED"
  ],
  OD: [
    "OD_KH", "OD_CU", "OD_GN", "OD_SA", "OD_BW"
  ],
  AP: [
    "AP_VS", "AP_GU", "AP_NTR", "AP_TRP", "AP_NE"
  ],
  TS: [
    "TS_HY", "TS_RA", "TS_MH", "TS_WL", "TS_KA"
  ],
  WB: [
    "WB_KO", "WB_PN", "WB_HR", "WB_MSD", "WB_BR"
  ],
  AS: [
    "AS_KM", "AS_DI", "AS_NN", "AS_CA", "AS_JO"
  ],
  GJ: [
    "GJ_AH", "GJ_ST", "GJ_VD", "GJ_RA", "GJ_GA"
  ],
  TR: [
    "TR_WT", "TR_GM", "TR_NT", "TR_DH"
  ],
  MH: [
    "MH_MC", "MH_PU", "MH_TH", "MH_NG", "MH_NS", "MH_AU"
  ],
  KA: [
    "KA_BN", "KA_MY", "KA_DH", "KA_BG"
  ],
  TN: [
    "TN_CH", "TN_CO", "TN_MA", "TN_TC", "TN_SA"
  ],
  PB: [
    "PB_LU", "PB_AM", "PB_JA", "PB_SAS", "PB_PA"
  ],
  KL: [
    "KL_TV", "KL_ER", "KL_KZ", "KL_TS", "KL_KL"
  ]
};

export const CODE_TO_RECORD = Object.entries(ALL_DISTRICTS_FLAT).reduce((acc, [districtCode, district]) => {
  acc[district.value] = districtCode
  return acc
}, {} as Record<string, string>);